const Nn = Object.prototype.toString;
function Dn(e) {
  switch (Nn.call(e)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
      return !0;
    default:
      return O(e, Error);
  }
}
function dt(e, t) {
  return Nn.call(e) === `[object ${t}]`;
}
function vn(e) {
  return dt(e, "ErrorEvent");
}
function qe(e) {
  return dt(e, "DOMError");
}
function pi(e) {
  return dt(e, "DOMException");
}
function F(e) {
  return dt(e, "String");
}
function In(e) {
  return e === null || typeof e != "object" && typeof e != "function";
}
function st(e) {
  return dt(e, "Object");
}
function ve(e) {
  return typeof Event < "u" && O(e, Event);
}
function hi(e) {
  return typeof Element < "u" && O(e, Element);
}
function wn(e) {
  return dt(e, "RegExp");
}
function j(e) {
  return !!(e && e.then && typeof e.then == "function");
}
function mi(e) {
  return st(e) && "nativeEvent" in e && "preventDefault" in e && "stopPropagation" in e;
}
function kn(e) {
  return typeof e == "number" && e !== e;
}
function O(e, t) {
  try {
    return e instanceof t;
  } catch {
    return !1;
  }
}
function Dt(e) {
  return e && e.Math == Math ? e : void 0;
}
const I = typeof globalThis == "object" && Dt(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && Dt(window) || typeof self == "object" && Dt(self) || typeof global == "object" && Dt(global) || function() {
  return this;
}() || {};
function Wt() {
  return I;
}
function Ie(e, t, n) {
  const i = n || I, r = i.__SENTRY__ = i.__SENTRY__ || {};
  return r[e] || (r[e] = t());
}
const Ot = Wt(), gi = 80;
function ot(e, t = {}) {
  try {
    let n = e;
    const i = 5, r = [];
    let s = 0, o = 0;
    const a = " > ", c = a.length;
    let u;
    const d = Array.isArray(t) ? t : t.keyAttrs, _ = !Array.isArray(t) && t.maxStringLength || gi;
    for (; n && s++ < i && (u = Ei(n, d), !(u === "html" || s > 1 && o + r.length * c + u.length >= _)); )
      r.push(u), o += u.length, n = n.parentNode;
    return r.reverse().join(a);
  } catch {
    return "<unknown>";
  }
}
function Ei(e, t) {
  const n = e, i = [];
  let r, s, o, a, c;
  if (!n || !n.tagName)
    return "";
  i.push(n.tagName.toLowerCase());
  const u = t && t.length ? t.filter((_) => n.getAttribute(_)).map((_) => [_, n.getAttribute(_)]) : null;
  if (u && u.length)
    u.forEach((_) => {
      i.push(`[${_[0]}="${_[1]}"]`);
    });
  else if (n.id && i.push(`#${n.id}`), r = n.className, r && F(r))
    for (s = r.split(/\s+/), c = 0; c < s.length; c++)
      i.push(`.${s[c]}`);
  const d = ["aria-label", "type", "name", "title", "alt"];
  for (c = 0; c < d.length; c++)
    o = d[c], a = n.getAttribute(o), a && i.push(`[${o}="${a}"]`);
  return i.join("");
}
function yi() {
  try {
    return Ot.document.location.href;
  } catch {
    return "";
  }
}
function Si(e) {
  return Ot.document && Ot.document.querySelector ? Ot.document.querySelector(e) : null;
}
class N extends Error {
  /** Display name of this error instance. */
  constructor(t, n = "warn") {
    super(t), this.message = t, this.name = new.target.prototype.constructor.name, Object.setPrototypeOf(this, new.target.prototype), this.logLevel = n;
  }
}
const Ti = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function Ri(e) {
  return e === "http" || e === "https";
}
function we(e, t = !1) {
  const { host: n, path: i, pass: r, port: s, projectId: o, protocol: a, publicKey: c } = e;
  return `${a}://${c}${t && r ? `:${r}` : ""}@${n}${s ? `:${s}` : ""}/${i && `${i}/`}${o}`;
}
function bi(e) {
  const t = Ti.exec(e);
  if (!t)
    throw new N(`Invalid Sentry Dsn: ${e}`);
  const [n, i, r = "", s, o = "", a] = t.slice(1);
  let c = "", u = a;
  const d = u.split("/");
  if (d.length > 1 && (c = d.slice(0, -1).join("/"), u = d.pop()), u) {
    const _ = u.match(/^\d+/);
    _ && (u = _[0]);
  }
  return Un({ host: s, pass: r, path: c, projectId: u, port: o, protocol: n, publicKey: i });
}
function Un(e) {
  return {
    protocol: e.protocol,
    publicKey: e.publicKey || "",
    pass: e.pass || "",
    host: e.host,
    port: e.port || "",
    path: e.path || "",
    projectId: e.projectId
  };
}
function Ni(e) {
  if (!(typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__))
    return;
  const { port: t, projectId: n, protocol: i } = e;
  if (["protocol", "publicKey", "host", "projectId"].forEach((s) => {
    if (!e[s])
      throw new N(`Invalid Sentry Dsn: ${s} missing`);
  }), !n.match(/^\d+$/))
    throw new N(`Invalid Sentry Dsn: Invalid projectId ${n}`);
  if (!Ri(i))
    throw new N(`Invalid Sentry Dsn: Invalid protocol ${i}`);
  if (t && isNaN(parseInt(t, 10)))
    throw new N(`Invalid Sentry Dsn: Invalid port ${t}`);
  return !0;
}
function Di(e) {
  const t = typeof e == "string" ? bi(e) : Un(e);
  return Ni(t), t;
}
const vi = "Sentry Logger ", Gt = ["debug", "info", "warn", "error", "log", "assert", "trace"];
function On(e) {
  if (!("console" in I))
    return e();
  const t = I.console, n = {};
  Gt.forEach((i) => {
    const r = t[i] && t[i].__sentry_original__;
    i in t && r && (n[i] = t[i], t[i] = r);
  });
  try {
    return e();
  } finally {
    Object.keys(n).forEach((i) => {
      t[i] = n[i];
    });
  }
}
function We() {
  let e = !1;
  const t = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    }
  };
  return typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__ ? Gt.forEach((n) => {
    t[n] = (...i) => {
      e && On(() => {
        I.console[n](`${vi}[${n}]:`, ...i);
      });
    };
  }) : Gt.forEach((n) => {
    t[n] = () => {
    };
  }), t;
}
let f;
typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__ ? f = Ie("logger", We) : f = We();
function pt(e, t = 0) {
  return typeof e != "string" || t === 0 || e.length <= t ? e : `${e.slice(0, t)}...`;
}
function ze(e, t) {
  if (!Array.isArray(e))
    return "";
  const n = [];
  for (let i = 0; i < e.length; i++) {
    const r = e[i];
    try {
      n.push(String(r));
    } catch {
      n.push("[value cannot be serialized]");
    }
  }
  return n.join(t);
}
function Ii(e, t, n = !1) {
  return F(e) ? wn(t) ? t.test(e) : F(t) ? n ? e === t : e.includes(t) : !1 : !1;
}
function zt(e, t = [], n = !1) {
  return t.some((i) => Ii(e, i, n));
}
function T(e, t, n) {
  if (!(t in e))
    return;
  const i = e[t], r = n(i);
  if (typeof r == "function")
    try {
      Bn(r, i);
    } catch {
    }
  e[t] = r;
}
function ke(e, t, n) {
  Object.defineProperty(e, t, {
    // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
    value: n,
    writable: !0,
    configurable: !0
  });
}
function Bn(e, t) {
  const n = t.prototype || {};
  e.prototype = t.prototype = n, ke(e, "__sentry_original__", t);
}
function Ue(e) {
  return e.__sentry_original__;
}
function wi(e) {
  return Object.keys(e).map((t) => `${encodeURIComponent(t)}=${encodeURIComponent(e[t])}`).join("&");
}
function An(e) {
  if (Dn(e))
    return {
      message: e.message,
      name: e.name,
      stack: e.stack,
      ...Xe(e)
    };
  if (ve(e)) {
    const t = {
      type: e.type,
      target: Ve(e.target),
      currentTarget: Ve(e.currentTarget),
      ...Xe(e)
    };
    return typeof CustomEvent < "u" && O(e, CustomEvent) && (t.detail = e.detail), t;
  } else
    return e;
}
function Ve(e) {
  try {
    return hi(e) ? ot(e) : Object.prototype.toString.call(e);
  } catch {
    return "<unknown>";
  }
}
function Xe(e) {
  if (typeof e == "object" && e !== null) {
    const t = {};
    for (const n in e)
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    return t;
  } else
    return {};
}
function ki(e, t = 40) {
  const n = Object.keys(An(e));
  if (n.sort(), !n.length)
    return "[object has no keys]";
  if (n[0].length >= t)
    return pt(n[0], t);
  for (let i = n.length; i > 0; i--) {
    const r = n.slice(0, i).join(", ");
    if (!(r.length > t))
      return i === n.length ? r : pt(r, t);
  }
  return "";
}
function P(e) {
  return fe(e, /* @__PURE__ */ new Map());
}
function fe(e, t) {
  if (st(e)) {
    const n = t.get(e);
    if (n !== void 0)
      return n;
    const i = {};
    t.set(e, i);
    for (const r of Object.keys(e))
      typeof e[r] < "u" && (i[r] = fe(e[r], t));
    return i;
  }
  if (Array.isArray(e)) {
    const n = t.get(e);
    if (n !== void 0)
      return n;
    const i = [];
    return t.set(e, i), e.forEach((r) => {
      i.push(fe(r, t));
    }), i;
  }
  return e;
}
const Gn = 50, Ke = /\(error: (.*)\)/;
function xn(...e) {
  const t = e.sort((n, i) => n[0] - i[0]).map((n) => n[1]);
  return (n, i = 0) => {
    const r = [], s = n.split(`
`);
    for (let o = i; o < s.length; o++) {
      const a = s[o];
      if (a.length > 1024)
        continue;
      const c = Ke.test(a) ? a.replace(Ke, "$1") : a;
      for (const u of t) {
        const d = u(c);
        if (d) {
          r.push(d);
          break;
        }
      }
      if (r.length >= Gn)
        break;
    }
    return Oi(r);
  };
}
function Ui(e) {
  return Array.isArray(e) ? xn(...e) : e;
}
function Oi(e) {
  if (!e.length)
    return [];
  const t = e.slice(0, Gn), n = t[t.length - 1].function;
  n && /sentryWrapped/.test(n) && t.pop(), t.reverse();
  const i = t[t.length - 1].function;
  return i && /captureMessage|captureException/.test(i) && t.pop(), t.map((r) => ({
    ...r,
    filename: r.filename || t[t.length - 1].filename,
    function: r.function || "?"
  }));
}
const re = "<anonymous>";
function H(e) {
  try {
    return !e || typeof e != "function" ? re : e.name || re;
  } catch {
    return re;
  }
}
const W = Wt();
function Yn() {
  if (!("fetch" in W))
    return !1;
  try {
    return new Headers(), new Request("http://www.example.com"), new Response(), !0;
  } catch {
    return !1;
  }
}
function le(e) {
  return e && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
}
function Bi() {
  if (!Yn())
    return !1;
  if (le(W.fetch))
    return !0;
  let e = !1;
  const t = W.document;
  if (t && typeof t.createElement == "function")
    try {
      const n = t.createElement("iframe");
      n.hidden = !0, t.head.appendChild(n), n.contentWindow && n.contentWindow.fetch && (e = le(n.contentWindow.fetch)), t.head.removeChild(n);
    } catch (n) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", n);
    }
  return e;
}
function Ai() {
  const e = W.chrome, t = e && e.app && e.app.runtime, n = "history" in W && !!W.history.pushState && !!W.history.replaceState;
  return !t && n;
}
const S = Wt(), ht = {}, Je = {};
function Gi(e) {
  if (!Je[e])
    switch (Je[e] = !0, e) {
      case "console":
        xi();
        break;
      case "dom":
        ji();
        break;
      case "xhr":
        Ci();
        break;
      case "fetch":
        Yi();
        break;
      case "history":
        Mi();
        break;
      case "error":
        qi();
        break;
      case "unhandledrejection":
        Wi();
        break;
      default:
        (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn("unknown instrumentation type:", e);
        return;
    }
}
function w(e, t) {
  ht[e] = ht[e] || [], ht[e].push(t), Gi(e);
}
function k(e, t) {
  if (!(!e || !ht[e]))
    for (const n of ht[e] || [])
      try {
        n(t);
      } catch (i) {
        (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.error(
          `Error while triggering instrumentation handler.
Type: ${e}
Name: ${H(n)}
Error:`,
          i
        );
      }
}
function xi() {
  "console" in S && Gt.forEach(function(e) {
    e in S.console && T(S.console, e, function(t) {
      return function(...n) {
        k("console", { args: n, level: e }), t && t.apply(S.console, n);
      };
    });
  });
}
function Yi() {
  Bi() && T(S, "fetch", function(e) {
    return function(...t) {
      const n = {
        args: t,
        fetchData: {
          method: $i(t),
          url: Pi(t)
        },
        startTimestamp: Date.now()
      };
      return k("fetch", {
        ...n
      }), e.apply(S, t).then(
        (i) => (k("fetch", {
          ...n,
          endTimestamp: Date.now(),
          response: i
        }), i),
        (i) => {
          throw k("fetch", {
            ...n,
            endTimestamp: Date.now(),
            error: i
          }), i;
        }
      );
    };
  });
}
function $i(e = []) {
  return "Request" in S && O(e[0], Request) && e[0].method ? String(e[0].method).toUpperCase() : e[1] && e[1].method ? String(e[1].method).toUpperCase() : "GET";
}
function Pi(e = []) {
  return typeof e[0] == "string" ? e[0] : "Request" in S && O(e[0], Request) ? e[0].url : String(e[0]);
}
function Ci() {
  if (!("XMLHttpRequest" in S))
    return;
  const e = XMLHttpRequest.prototype;
  T(e, "open", function(t) {
    return function(...n) {
      const i = n[1], r = this.__sentry_xhr__ = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        method: F(n[0]) ? n[0].toUpperCase() : n[0],
        url: n[1]
      };
      F(i) && r.method === "POST" && i.match(/sentry_key/) && (this.__sentry_own_request__ = !0);
      const s = () => {
        const o = this.__sentry_xhr__;
        if (o && this.readyState === 4) {
          try {
            o.status_code = this.status;
          } catch {
          }
          k("xhr", {
            args: n,
            endTimestamp: Date.now(),
            startTimestamp: Date.now(),
            xhr: this
          });
        }
      };
      return "onreadystatechange" in this && typeof this.onreadystatechange == "function" ? T(this, "onreadystatechange", function(o) {
        return function(...a) {
          return s(), o.apply(this, a);
        };
      }) : this.addEventListener("readystatechange", s), t.apply(this, n);
    };
  }), T(e, "send", function(t) {
    return function(...n) {
      return this.__sentry_xhr__ && n[0] !== void 0 && (this.__sentry_xhr__.body = n[0]), k("xhr", {
        args: n,
        startTimestamp: Date.now(),
        xhr: this
      }), t.apply(this, n);
    };
  });
}
let vt;
function Mi() {
  if (!Ai())
    return;
  const e = S.onpopstate;
  S.onpopstate = function(...n) {
    const i = S.location.href, r = vt;
    if (vt = i, k("history", {
      from: r,
      to: i
    }), e)
      try {
        return e.apply(this, n);
      } catch {
      }
  };
  function t(n) {
    return function(...i) {
      const r = i.length > 2 ? i[2] : void 0;
      if (r) {
        const s = vt, o = String(r);
        vt = o, k("history", {
          from: s,
          to: o
        });
      }
      return n.apply(this, i);
    };
  }
  T(S.history, "pushState", t), T(S.history, "replaceState", t);
}
const Li = 1e3;
let It, wt;
function Fi(e, t) {
  if (!e || e.type !== t.type)
    return !0;
  try {
    if (e.target !== t.target)
      return !0;
  } catch {
  }
  return !1;
}
function Hi(e) {
  if (e.type !== "keypress")
    return !1;
  try {
    const t = e.target;
    if (!t || !t.tagName)
      return !0;
    if (t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.isContentEditable)
      return !1;
  } catch {
  }
  return !0;
}
function Qe(e, t = !1) {
  return (n) => {
    if (!n || wt === n || Hi(n))
      return;
    const i = n.type === "keypress" ? "input" : n.type;
    It === void 0 ? (e({
      event: n,
      name: i,
      global: t
    }), wt = n) : Fi(wt, n) && (e({
      event: n,
      name: i,
      global: t
    }), wt = n), clearTimeout(It), It = S.setTimeout(() => {
      It = void 0;
    }, Li);
  };
}
function ji() {
  if (!("document" in S))
    return;
  const e = k.bind(null, "dom"), t = Qe(e, !0);
  S.document.addEventListener("click", t, !1), S.document.addEventListener("keypress", t, !1), ["EventTarget", "Node"].forEach((n) => {
    const i = S[n] && S[n].prototype;
    !i || !i.hasOwnProperty || !i.hasOwnProperty("addEventListener") || (T(i, "addEventListener", function(r) {
      return function(s, o, a) {
        if (s === "click" || s == "keypress")
          try {
            const c = this, u = c.__sentry_instrumentation_handlers__ = c.__sentry_instrumentation_handlers__ || {}, d = u[s] = u[s] || { refCount: 0 };
            if (!d.handler) {
              const _ = Qe(e);
              d.handler = _, r.call(this, s, _, a);
            }
            d.refCount++;
          } catch {
          }
        return r.call(this, s, o, a);
      };
    }), T(
      i,
      "removeEventListener",
      function(r) {
        return function(s, o, a) {
          if (s === "click" || s == "keypress")
            try {
              const c = this, u = c.__sentry_instrumentation_handlers__ || {}, d = u[s];
              d && (d.refCount--, d.refCount <= 0 && (r.call(this, s, d.handler, a), d.handler = void 0, delete u[s]), Object.keys(u).length === 0 && delete c.__sentry_instrumentation_handlers__);
            } catch {
            }
          return r.call(this, s, o, a);
        };
      }
    ));
  });
}
let se = null;
function qi() {
  se = S.onerror, S.onerror = function(e, t, n, i, r) {
    return k("error", {
      column: i,
      error: r,
      line: n,
      msg: e,
      url: t
    }), se ? se.apply(this, arguments) : !1;
  };
}
let oe = null;
function Wi() {
  oe = S.onunhandledrejection, S.onunhandledrejection = function(e) {
    return k("unhandledrejection", e), oe ? oe.apply(this, arguments) : !0;
  };
}
function zi() {
  const e = typeof WeakSet == "function", t = e ? /* @__PURE__ */ new WeakSet() : [];
  function n(r) {
    if (e)
      return t.has(r) ? !0 : (t.add(r), !1);
    for (let s = 0; s < t.length; s++)
      if (t[s] === r)
        return !0;
    return t.push(r), !1;
  }
  function i(r) {
    if (e)
      t.delete(r);
    else
      for (let s = 0; s < t.length; s++)
        if (t[s] === r) {
          t.splice(s, 1);
          break;
        }
  }
  return [n, i];
}
function C() {
  const e = I, t = e.crypto || e.msCrypto;
  if (t && t.randomUUID)
    return t.randomUUID().replace(/-/g, "");
  const n = t && t.getRandomValues ? () => t.getRandomValues(new Uint8Array(1))[0] : () => Math.random() * 16;
  return ([1e7] + 1e3 + 4e3 + 8e3 + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (n() & 15) >> i / 4).toString(16)
    )
  );
}
function $n(e) {
  return e.exception && e.exception.values ? e.exception.values[0] : void 0;
}
function z(e) {
  const { message: t, event_id: n } = e;
  if (t)
    return t;
  const i = $n(e);
  return i ? i.type && i.value ? `${i.type}: ${i.value}` : i.type || i.value || n || "<unknown>" : n || "<unknown>";
}
function pe(e, t, n) {
  const i = e.exception = e.exception || {}, r = i.values = i.values || [], s = r[0] = r[0] || {};
  s.value || (s.value = t || ""), s.type || (s.type = n || "Error");
}
function Et(e, t) {
  const n = $n(e);
  if (!n)
    return;
  const i = { type: "generic", handled: !0 }, r = n.mechanism;
  if (n.mechanism = { ...i, ...r, ...t }, t && "data" in t) {
    const s = { ...r && r.data, ...t.data };
    n.mechanism.data = s;
  }
}
function Ze(e) {
  if (e && e.__sentry_captured__)
    return !0;
  try {
    ke(e, "__sentry_captured__", !0);
  } catch {
  }
  return !1;
}
function yt(e) {
  return Array.isArray(e) ? e : [e];
}
function Vi() {
  return typeof __SENTRY_BROWSER_BUNDLE__ < "u" && !!__SENTRY_BROWSER_BUNDLE__;
}
function Xi() {
  return "npm";
}
function Oe() {
  return !Vi() && Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]";
}
function $(e, t) {
  return e.require(t);
}
function V(e) {
  let t;
  try {
    t = $(module, e);
  } catch {
  }
  try {
    const { cwd: n } = $(module, "process");
    t = $(module, `${n()}/node_modules/${e}`);
  } catch {
  }
  return t;
}
function G(e, t = 1 / 0, n = 1 / 0) {
  try {
    return he("", e, t, n);
  } catch (i) {
    return { ERROR: `**non-serializable** (${i})` };
  }
}
function Pn(e, t = 3, n = 100 * 1024) {
  const i = G(e, t);
  return Zi(i) > n ? Pn(e, t - 1, n) : i;
}
function he(e, t, n = 1 / 0, i = 1 / 0, r = zi()) {
  const [s, o] = r;
  if (t === null || ["number", "boolean", "string"].includes(typeof t) && !kn(t))
    return t;
  const a = Ki(e, t);
  if (!a.startsWith("[object "))
    return a;
  if (t.__sentry_skip_normalization__)
    return t;
  let c = n;
  if (typeof t.__sentry_override_normalization_depth__ == "number" && (c = t.__sentry_override_normalization_depth__), c === 0)
    return a.replace("object ", "");
  if (s(t))
    return "[Circular ~]";
  const u = t;
  if (u && typeof u.toJSON == "function")
    try {
      const l = u.toJSON();
      return he("", l, c - 1, i, r);
    } catch {
    }
  const d = Array.isArray(t) ? [] : {};
  let _ = 0;
  const p = An(t);
  for (const l in p) {
    if (!Object.prototype.hasOwnProperty.call(p, l))
      continue;
    if (_ >= i) {
      d[l] = "[MaxProperties ~]";
      break;
    }
    const m = p[l];
    d[l] = he(l, m, c - 1, i, r), _++;
  }
  return o(t), d;
}
function Ki(e, t) {
  try {
    return e === "domain" && t && typeof t == "object" && t._events ? "[Domain]" : e === "domainEmitter" ? "[DomainEmitter]" : typeof global < "u" && t === global ? "[Global]" : typeof window < "u" && t === window ? "[Window]" : typeof document < "u" && t === document ? "[Document]" : mi(t) ? "[SyntheticEvent]" : typeof t == "number" && t !== t ? "[NaN]" : t === void 0 ? "[undefined]" : typeof t == "function" ? `[Function: ${H(t)}]` : typeof t == "symbol" ? `[${String(t)}]` : typeof t == "bigint" ? `[BigInt: ${String(t)}]` : `[object ${Ji(t)}]`;
  } catch (n) {
    return `**non-serializable** (${n})`;
  }
}
function Ji(e) {
  const t = Object.getPrototypeOf(e);
  return t ? t.constructor.name : "null prototype";
}
function Qi(e) {
  return ~-encodeURI(e).split(/%..|./).length;
}
function Zi(e) {
  return Qi(JSON.stringify(e));
}
var B;
(function(e) {
  e[e.PENDING = 0] = "PENDING";
  const n = 1;
  e[e.RESOLVED = n] = "RESOLVED";
  const i = 2;
  e[e.REJECTED = i] = "REJECTED";
})(B || (B = {}));
function X(e) {
  return new D((t) => {
    t(e);
  });
}
function xt(e) {
  return new D((t, n) => {
    n(e);
  });
}
class D {
  __init() {
    this._state = B.PENDING;
  }
  __init2() {
    this._handlers = [];
  }
  constructor(t) {
    D.prototype.__init.call(this), D.prototype.__init2.call(this), D.prototype.__init3.call(this), D.prototype.__init4.call(this), D.prototype.__init5.call(this), D.prototype.__init6.call(this);
    try {
      t(this._resolve, this._reject);
    } catch (n) {
      this._reject(n);
    }
  }
  /** JSDoc */
  then(t, n) {
    return new D((i, r) => {
      this._handlers.push([
        !1,
        (s) => {
          if (!t)
            i(s);
          else
            try {
              i(t(s));
            } catch (o) {
              r(o);
            }
        },
        (s) => {
          if (!n)
            r(s);
          else
            try {
              i(n(s));
            } catch (o) {
              r(o);
            }
        }
      ]), this._executeHandlers();
    });
  }
  /** JSDoc */
  catch(t) {
    return this.then((n) => n, t);
  }
  /** JSDoc */
  finally(t) {
    return new D((n, i) => {
      let r, s;
      return this.then(
        (o) => {
          s = !1, r = o, t && t();
        },
        (o) => {
          s = !0, r = o, t && t();
        }
      ).then(() => {
        if (s) {
          i(r);
          return;
        }
        n(r);
      });
    });
  }
  /** JSDoc */
  __init3() {
    this._resolve = (t) => {
      this._setResult(B.RESOLVED, t);
    };
  }
  /** JSDoc */
  __init4() {
    this._reject = (t) => {
      this._setResult(B.REJECTED, t);
    };
  }
  /** JSDoc */
  __init5() {
    this._setResult = (t, n) => {
      if (this._state === B.PENDING) {
        if (j(n)) {
          n.then(this._resolve, this._reject);
          return;
        }
        this._state = t, this._value = n, this._executeHandlers();
      }
    };
  }
  /** JSDoc */
  __init6() {
    this._executeHandlers = () => {
      if (this._state === B.PENDING)
        return;
      const t = this._handlers.slice();
      this._handlers = [], t.forEach((n) => {
        n[0] || (this._state === B.RESOLVED && n[1](this._value), this._state === B.REJECTED && n[2](this._value), n[0] = !0);
      });
    };
  }
}
function tr(e) {
  const t = [];
  function n() {
    return e === void 0 || t.length < e;
  }
  function i(o) {
    return t.splice(t.indexOf(o), 1)[0];
  }
  function r(o) {
    if (!n())
      return xt(new N("Not adding Promise because buffer limit was reached."));
    const a = o();
    return t.indexOf(a) === -1 && t.push(a), a.then(() => i(a)).then(
      null,
      () => i(a).then(null, () => {
      })
    ), a;
  }
  function s(o) {
    return new D((a, c) => {
      let u = t.length;
      if (!u)
        return a(!0);
      const d = setTimeout(() => {
        o && o > 0 && a(!1);
      }, o);
      t.forEach((_) => {
        X(_).then(() => {
          --u || (clearTimeout(d), a(!0));
        }, c);
      });
    });
  }
  return {
    $: t,
    add: r,
    drain: s
  };
}
function ae(e) {
  if (!e)
    return {};
  const t = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!t)
    return {};
  const n = t[6] || "", i = t[8] || "";
  return {
    host: t[4],
    path: t[5],
    protocol: t[2],
    relative: t[5] + n + i
    // everything minus origin
  };
}
function er(e) {
  return e.split(/[\?#]/, 1)[0];
}
function Yt(e) {
  return e.split(/\\?\//).filter((t) => t.length > 0 && t !== ",").length;
}
function nr(e, t = {}) {
  const n = e.method && e.method.toUpperCase();
  let i = "", r = "url";
  t.customRoute || e.route ? (i = t.customRoute || `${e.baseUrl || ""}${e.route && e.route.path}`, r = "route") : (e.originalUrl || e.url) && (i = er(e.originalUrl || e.url || ""));
  let s = "";
  return t.method && n && (s += n), t.method && t.path && (s += " "), t.path && i && (s += i), [s, r];
}
const ir = ["fatal", "error", "warning", "log", "info", "debug"];
function rr(e) {
  return e === "warn" ? "warning" : ir.includes(e) ? e : "log";
}
const Cn = Wt(), me = {
  nowSeconds: () => Date.now() / 1e3
};
function sr() {
  const { performance: e } = Cn;
  if (!e || !e.now)
    return;
  const t = Date.now() - e.now();
  return {
    now: () => e.now(),
    timeOrigin: t
  };
}
function or() {
  try {
    return $(module, "perf_hooks").performance;
  } catch {
    return;
  }
}
const ce = Oe() ? or() : sr(), tn = ce === void 0 ? me : {
  nowSeconds: () => (ce.timeOrigin + ce.now()) / 1e3
}, Vt = me.nowSeconds.bind(me), Xt = tn.nowSeconds.bind(tn), St = Xt, at = (() => {
  const { performance: e } = Cn;
  if (!e || !e.now)
    return;
  const t = 3600 * 1e3, n = e.now(), i = Date.now(), r = e.timeOrigin ? Math.abs(e.timeOrigin + n - i) : t, s = r < t, o = e.timing && e.timing.navigationStart, c = typeof o == "number" ? Math.abs(o + n - i) : t, u = c < t;
  return s || u ? r <= c ? e.timeOrigin : o : i;
})(), ar = new RegExp(
  "^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$"
  // whitespace
);
function cr(e) {
  const t = e.match(ar);
  if (!e || !t)
    return;
  let n;
  return t[3] === "1" ? n = !0 : t[3] === "0" && (n = !1), {
    traceId: t[1],
    parentSampled: n,
    parentSpanId: t[2]
  };
}
function Kt(e, t = []) {
  return [e, t];
}
function ur(e, t) {
  const [n, i] = e;
  return [n, [...i, t]];
}
function en(e, t) {
  const n = e[1];
  for (const i of n) {
    const r = i[0].type;
    if (t(i, r))
      return !0;
  }
  return !1;
}
function ge(e, t) {
  return (t || new TextEncoder()).encode(e);
}
function _r(e, t) {
  const [n, i] = e;
  let r = JSON.stringify(n);
  function s(o) {
    typeof r == "string" ? r = typeof o == "string" ? r + o : [ge(r, t), o] : r.push(typeof o == "string" ? ge(o, t) : o);
  }
  for (const o of i) {
    const [a, c] = o;
    if (s(`
${JSON.stringify(a)}
`), typeof c == "string" || c instanceof Uint8Array)
      s(c);
    else {
      let u;
      try {
        u = JSON.stringify(c);
      } catch {
        u = JSON.stringify(G(c));
      }
      s(u);
    }
  }
  return typeof r == "string" ? r : dr(r);
}
function dr(e) {
  const t = e.reduce((r, s) => r + s.length, 0), n = new Uint8Array(t);
  let i = 0;
  for (const r of e)
    n.set(r, i), i += r.length;
  return n;
}
function fr(e, t) {
  const n = typeof e.data == "string" ? ge(e.data, t) : e.data;
  return [
    P({
      type: "attachment",
      length: n.length,
      filename: e.filename,
      content_type: e.contentType,
      attachment_type: e.attachmentType
    }),
    n
  ];
}
const lr = {
  session: "session",
  sessions: "session",
  attachment: "attachment",
  transaction: "transaction",
  event: "error",
  client_report: "internal",
  user_report: "default",
  profile: "profile",
  replay_event: "replay",
  replay_recording: "replay"
};
function nn(e) {
  return lr[e];
}
function Mn(e) {
  if (!e || !e.sdk)
    return;
  const { name: t, version: n } = e.sdk;
  return { name: t, version: n };
}
function pr(e, t, n, i) {
  const r = e.sdkProcessingMetadata && e.sdkProcessingMetadata.dynamicSamplingContext;
  return {
    event_id: e.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...t && { sdk: t },
    ...!!n && { dsn: we(i) },
    ...e.type === "transaction" && r && {
      trace: P({ ...r })
    }
  };
}
function hr(e, t, n) {
  const i = [
    { type: "client_report" },
    {
      timestamp: n || Vt(),
      discarded_events: e
    }
  ];
  return Kt(t ? { dsn: t } : {}, [i]);
}
const mr = 60 * 1e3;
function gr(e, t = Date.now()) {
  const n = parseInt(`${e}`, 10);
  if (!isNaN(n))
    return n * 1e3;
  const i = Date.parse(`${e}`);
  return isNaN(i) ? mr : i - t;
}
function Er(e, t) {
  return e[t] || e.all || 0;
}
function yr(e, t, n = Date.now()) {
  return Er(e, t) > n;
}
function Sr(e, { statusCode: t, headers: n }, i = Date.now()) {
  const r = {
    ...e
  }, s = n && n["x-sentry-rate-limits"], o = n && n["retry-after"];
  if (s)
    for (const a of s.trim().split(",")) {
      const [c, u] = a.split(":", 2), d = parseInt(c, 10), _ = (isNaN(d) ? 60 : d) * 1e3;
      if (!u)
        r.all = i + _;
      else
        for (const p of u.split(";"))
          r[p] = i + _;
    }
  else
    o ? r.all = i + gr(o, i) : t === 429 && (r.all = i + 60 * 1e3);
  return r;
}
const Ee = "baggage", Ln = "sentry-", Tr = /^sentry-/, Rr = 8192;
function br(e) {
  if (!F(e) && !Array.isArray(e))
    return;
  let t = {};
  if (Array.isArray(e))
    t = e.reduce((i, r) => {
      const s = rn(r);
      return {
        ...i,
        ...s
      };
    }, {});
  else {
    if (!e)
      return;
    t = rn(e);
  }
  const n = Object.entries(t).reduce((i, [r, s]) => {
    if (r.match(Tr)) {
      const o = r.slice(Ln.length);
      i[o] = s;
    }
    return i;
  }, {});
  if (Object.keys(n).length > 0)
    return n;
}
function Fn(e) {
  const t = Object.entries(e).reduce(
    (n, [i, r]) => (r && (n[`${Ln}${i}`] = r), n),
    {}
  );
  return Nr(t);
}
function rn(e) {
  return e.split(",").map((t) => t.split("=").map((n) => decodeURIComponent(n.trim()))).reduce((t, [n, i]) => (t[n] = i, t), {});
}
function Nr(e) {
  if (Object.keys(e).length !== 0)
    return Object.entries(e).reduce((t, [n, i], r) => {
      const s = `${encodeURIComponent(n)}=${encodeURIComponent(i)}`, o = r === 0 ? s : `${t},${s}`;
      return o.length > Rr ? ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn(
        `Not adding key: ${n} with val: ${i} to baggage header due to exceeding baggage size limits.`
      ), t) : o;
    }, "");
}
const Be = "production";
function Dr(e) {
  const t = Xt(), n = {
    sid: C(),
    init: !0,
    timestamp: t,
    started: t,
    duration: 0,
    status: "ok",
    errors: 0,
    ignoreDuration: !1,
    toJSON: () => Ir(n)
  };
  return e && ct(n, e), n;
}
function ct(e, t = {}) {
  if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), !e.did && !t.did && (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || Xt(), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = t.sid.length === 32 ? t.sid : C()), t.init !== void 0 && (e.init = t.init), !e.did && t.did && (e.did = `${t.did}`), typeof t.started == "number" && (e.started = t.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof t.duration == "number")
    e.duration = t.duration;
  else {
    const n = e.timestamp - e.started;
    e.duration = n >= 0 ? n : 0;
  }
  t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), typeof t.errors == "number" && (e.errors = t.errors), t.status && (e.status = t.status);
}
function vr(e, t) {
  let n = {};
  t ? n = { status: t } : e.status === "ok" && (n = { status: "exited" }), ct(e, n);
}
function Ir(e) {
  return P({
    sid: `${e.sid}`,
    init: e.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(e.started * 1e3).toISOString(),
    timestamp: new Date(e.timestamp * 1e3).toISOString(),
    status: e.status,
    errors: e.errors,
    did: typeof e.did == "number" || typeof e.did == "string" ? `${e.did}` : void 0,
    duration: e.duration,
    attrs: {
      release: e.release,
      environment: e.environment,
      ip_address: e.ipAddress,
      user_agent: e.userAgent
    }
  });
}
const wr = 100;
class M {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called after {@link applyToEvent}. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  // eslint-disable-next-line deprecation/deprecation
  /** Transaction Name */
  /** Span */
  /** Session */
  /** Request Mode Session Status */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {};
  }
  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
  static clone(t) {
    const n = new M();
    return t && (n._breadcrumbs = [...t._breadcrumbs], n._tags = { ...t._tags }, n._extra = { ...t._extra }, n._contexts = { ...t._contexts }, n._user = t._user, n._level = t._level, n._span = t._span, n._session = t._session, n._transactionName = t._transactionName, n._fingerprint = t._fingerprint, n._eventProcessors = [...t._eventProcessors], n._requestSession = t._requestSession, n._attachments = [...t._attachments], n._sdkProcessingMetadata = { ...t._sdkProcessingMetadata }), n;
  }
  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
  addScopeListener(t) {
    this._scopeListeners.push(t);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(t) {
    return this._eventProcessors.push(t), this;
  }
  /**
   * @inheritDoc
   */
  setUser(t) {
    return this._user = t || {}, this._session && ct(this._session, { user: t }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(t) {
    return this._requestSession = t, this;
  }
  /**
   * @inheritDoc
   */
  setTags(t) {
    return this._tags = {
      ...this._tags,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(t, n) {
    return this._tags = { ...this._tags, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(t) {
    return this._extra = {
      ...this._extra,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(t, n) {
    return this._extra = { ...this._extra, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(t) {
    return this._fingerprint = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(t) {
    return this._level = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(t) {
    return this._transactionName = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(t, n) {
    return n === null ? delete this._contexts[t] : this._contexts[t] = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSpan(t) {
    return this._span = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSpan() {
    return this._span;
  }
  /**
   * @inheritDoc
   */
  getTransaction() {
    const t = this.getSpan();
    return t && t.transaction;
  }
  /**
   * @inheritDoc
   */
  setSession(t) {
    return t ? this._session = t : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(t) {
    if (!t)
      return this;
    if (typeof t == "function") {
      const n = t(this);
      return n instanceof M ? n : this;
    }
    return t instanceof M ? (this._tags = { ...this._tags, ...t._tags }, this._extra = { ...this._extra, ...t._extra }, this._contexts = { ...this._contexts, ...t._contexts }, t._user && Object.keys(t._user).length && (this._user = t._user), t._level && (this._level = t._level), t._fingerprint && (this._fingerprint = t._fingerprint), t._requestSession && (this._requestSession = t._requestSession)) : st(t) && (t = t, this._tags = { ...this._tags, ...t.tags }, this._extra = { ...this._extra, ...t.extra }, this._contexts = { ...this._contexts, ...t.contexts }, t.user && (this._user = t.user), t.level && (this._level = t.level), t.fingerprint && (this._fingerprint = t.fingerprint), t.requestSession && (this._requestSession = t.requestSession)), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._span = void 0, this._session = void 0, this._notifyScopeListeners(), this._attachments = [], this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(t, n) {
    const i = typeof n == "number" ? n : wr;
    if (i <= 0)
      return this;
    const r = {
      timestamp: Vt(),
      ...t
    };
    return this._breadcrumbs = [...this._breadcrumbs, r].slice(-i), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(t) {
    return this._attachments.push(t), this;
  }
  /**
   * @inheritDoc
   */
  getAttachments() {
    return this._attachments;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */
  applyToEvent(t, n = {}) {
    if (this._extra && Object.keys(this._extra).length && (t.extra = { ...this._extra, ...t.extra }), this._tags && Object.keys(this._tags).length && (t.tags = { ...this._tags, ...t.tags }), this._user && Object.keys(this._user).length && (t.user = { ...this._user, ...t.user }), this._contexts && Object.keys(this._contexts).length && (t.contexts = { ...this._contexts, ...t.contexts }), this._level && (t.level = this._level), this._transactionName && (t.transaction = this._transactionName), this._span) {
      t.contexts = { trace: this._span.getTraceContext(), ...t.contexts };
      const i = this._span.transaction && this._span.transaction.name;
      i && (t.tags = { transaction: i, ...t.tags });
    }
    return this._applyFingerprint(t), t.breadcrumbs = [...t.breadcrumbs || [], ...this._breadcrumbs], t.breadcrumbs = t.breadcrumbs.length > 0 ? t.breadcrumbs : void 0, t.sdkProcessingMetadata = { ...t.sdkProcessingMetadata, ...this._sdkProcessingMetadata }, this._notifyEventProcessors([...Hn(), ...this._eventProcessors], t, n);
  }
  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
  setSDKProcessingMetadata(t) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...t }, this;
  }
  /**
   * This will be called after {@link applyToEvent} is finished.
   */
  _notifyEventProcessors(t, n, i, r = 0) {
    return new D((s, o) => {
      const a = t[r];
      if (n === null || typeof a != "function")
        s(n);
      else {
        const c = a({ ...n }, i);
        (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && a.id && c === null && f.log(`Event processor "${a.id}" dropped event`), j(c) ? c.then((u) => this._notifyEventProcessors(t, u, i, r + 1).then(s)).then(null, o) : this._notifyEventProcessors(t, c, i, r + 1).then(s).then(null, o);
      }
    });
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((t) => {
      t(this);
    }), this._notifyingListeners = !1);
  }
  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
  _applyFingerprint(t) {
    t.fingerprint = t.fingerprint ? yt(t.fingerprint) : [], this._fingerprint && (t.fingerprint = t.fingerprint.concat(this._fingerprint)), t.fingerprint && !t.fingerprint.length && delete t.fingerprint;
  }
}
function Hn() {
  return Ie("globalEventProcessors", () => []);
}
function Ae(e) {
  Hn().push(e);
}
const Ge = 4, kr = 100;
class xe {
  /** Is a {@link Layer}[] containing the client and scope */
  /** Contains the last event id of a captured event.  */
  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
  constructor(t, n = new M(), i = Ge) {
    this._version = i, this._stack = [{ scope: n }], t && this.bindClient(t);
  }
  /**
   * @inheritDoc
   */
  isOlderThan(t) {
    return this._version < t;
  }
  /**
   * @inheritDoc
   */
  bindClient(t) {
    const n = this.getStackTop();
    n.client = t, t && t.setupIntegrations && t.setupIntegrations();
  }
  /**
   * @inheritDoc
   */
  pushScope() {
    const t = M.clone(this.getScope());
    return this.getStack().push({
      client: this.getClient(),
      scope: t
    }), t;
  }
  /**
   * @inheritDoc
   */
  popScope() {
    return this.getStack().length <= 1 ? !1 : !!this.getStack().pop();
  }
  /**
   * @inheritDoc
   */
  withScope(t) {
    const n = this.pushScope();
    try {
      t(n);
    } finally {
      this.popScope();
    }
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this.getStackTop().client;
  }
  /** Returns the scope of the top stack. */
  getScope() {
    return this.getStackTop().scope;
  }
  /** Returns the scope stack for domains or the process. */
  getStack() {
    return this._stack;
  }
  /** Returns the topmost scope layer in the order domain > local > process. */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * @inheritDoc
   */
  captureException(t, n) {
    const i = this._lastEventId = n && n.event_id ? n.event_id : C(), r = new Error("Sentry syntheticException");
    return this._withClient((s, o) => {
      s.captureException(
        t,
        {
          originalException: t,
          syntheticException: r,
          ...n,
          event_id: i
        },
        o
      );
    }), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(t, n, i) {
    const r = this._lastEventId = i && i.event_id ? i.event_id : C(), s = new Error(t);
    return this._withClient((o, a) => {
      o.captureMessage(
        t,
        n,
        {
          originalException: t,
          syntheticException: s,
          ...i,
          event_id: r
        },
        a
      );
    }), r;
  }
  /**
   * @inheritDoc
   */
  captureEvent(t, n) {
    const i = n && n.event_id ? n.event_id : C();
    return t.type || (this._lastEventId = i), this._withClient((r, s) => {
      r.captureEvent(t, { ...n, event_id: i }, s);
    }), i;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(t, n) {
    const { scope: i, client: r } = this.getStackTop();
    if (!r)
      return;
    const { beforeBreadcrumb: s = null, maxBreadcrumbs: o = kr } = r.getOptions && r.getOptions() || {};
    if (o <= 0)
      return;
    const c = { timestamp: Vt(), ...t }, u = s ? On(() => s(c, n)) : c;
    u !== null && (r.emit && r.emit("beforeAddBreadcrumb", u, n), i.addBreadcrumb(u, o));
  }
  /**
   * @inheritDoc
   */
  setUser(t) {
    this.getScope().setUser(t);
  }
  /**
   * @inheritDoc
   */
  setTags(t) {
    this.getScope().setTags(t);
  }
  /**
   * @inheritDoc
   */
  setExtras(t) {
    this.getScope().setExtras(t);
  }
  /**
   * @inheritDoc
   */
  setTag(t, n) {
    this.getScope().setTag(t, n);
  }
  /**
   * @inheritDoc
   */
  setExtra(t, n) {
    this.getScope().setExtra(t, n);
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setContext(t, n) {
    this.getScope().setContext(t, n);
  }
  /**
   * @inheritDoc
   */
  configureScope(t) {
    const { scope: n, client: i } = this.getStackTop();
    i && t(n);
  }
  /**
   * @inheritDoc
   */
  run(t) {
    const n = sn(this);
    try {
      t(this);
    } finally {
      sn(n);
    }
  }
  /**
   * @inheritDoc
   */
  getIntegration(t) {
    const n = this.getClient();
    if (!n)
      return null;
    try {
      return n.getIntegration(t);
    } catch {
      return (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn(`Cannot retrieve integration ${t.id} from the current Hub`), null;
    }
  }
  /**
   * @inheritDoc
   */
  startTransaction(t, n) {
    return this._callExtensionMethod("startTransaction", t, n);
  }
  /**
   * @inheritDoc
   */
  traceHeaders() {
    return this._callExtensionMethod("traceHeaders");
  }
  /**
   * @inheritDoc
   */
  captureSession(t = !1) {
    if (t)
      return this.endSession();
    this._sendSessionUpdate();
  }
  /**
   * @inheritDoc
   */
  endSession() {
    const n = this.getStackTop().scope, i = n.getSession();
    i && vr(i), this._sendSessionUpdate(), n.setSession();
  }
  /**
   * @inheritDoc
   */
  startSession(t) {
    const { scope: n, client: i } = this.getStackTop(), { release: r, environment: s = Be } = i && i.getOptions() || {}, { userAgent: o } = I.navigator || {}, a = Dr({
      release: r,
      environment: s,
      user: n.getUser(),
      ...o && { userAgent: o },
      ...t
    }), c = n.getSession && n.getSession();
    return c && c.status === "ok" && ct(c, { status: "exited" }), this.endSession(), n.setSession(a), a;
  }
  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
  shouldSendDefaultPii() {
    const t = this.getClient(), n = t && t.getOptions();
    return !!(n && n.sendDefaultPii);
  }
  /**
   * Sends the current Session on the scope
   */
  _sendSessionUpdate() {
    const { scope: t, client: n } = this.getStackTop();
    if (!t)
      return;
    const i = t.getSession();
    i && n && n.captureSession && n.captureSession(i);
  }
  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
  _withClient(t) {
    const { scope: n, client: i } = this.getStackTop();
    i && t(i, n);
  }
  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _callExtensionMethod(t, ...n) {
    const r = ft().__SENTRY__;
    if (r && r.extensions && typeof r.extensions[t] == "function")
      return r.extensions[t].apply(this, n);
    (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn(`Extension method ${t} couldn't be found, doing nothing.`);
  }
}
function ft() {
  return I.__SENTRY__ = I.__SENTRY__ || {
    extensions: {},
    hub: void 0
  }, I;
}
function sn(e) {
  const t = ft(), n = Y(t);
  return Ye(t, e), n;
}
function E() {
  const e = ft();
  return (!jn(e) || Y(e).isOlderThan(Ge)) && Ye(e, new xe()), Oe() ? Ur(e) : Y(e);
}
function Ur(e) {
  try {
    const t = ft().__SENTRY__, n = t && t.extensions && t.extensions.domain && t.extensions.domain.active;
    if (!n)
      return Y(e);
    if (!jn(n) || Y(n).isOlderThan(Ge)) {
      const i = Y(e).getStackTop();
      Ye(n, new xe(i.client, M.clone(i.scope)));
    }
    return Y(n);
  } catch {
    return Y(e);
  }
}
function jn(e) {
  return !!(e && e.__SENTRY__ && e.__SENTRY__.hub);
}
function Y(e) {
  return Ie("hub", () => new xe(), e);
}
function Ye(e, t) {
  if (!e)
    return !1;
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.hub = t, !0;
}
function Jt(e) {
  if (typeof __SENTRY_TRACING__ == "boolean" && !__SENTRY_TRACING__)
    return !1;
  const t = E().getClient(), n = e || t && t.getOptions();
  return !!n && (n.enableTracing || "tracesSampleRate" in n || "tracesSampler" in n);
}
function Qt(e) {
  return (e || E()).getScope().getTransaction();
}
let on = !1;
function Or() {
  on || (on = !0, w("error", ye), w("unhandledrejection", ye));
}
function ye() {
  const e = Qt();
  if (e) {
    const t = "internal_error";
    (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log(`[Tracing] Transaction: ${t} -> Global error occured`), e.setStatus(t);
  }
}
ye.tag = "sentry_tracingErrorCallback";
class Zt {
  __init() {
    this.spans = [];
  }
  constructor(t = 1e3) {
    Zt.prototype.__init.call(this), this._maxlen = t;
  }
  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */
  add(t) {
    this.spans.length > this._maxlen ? t.spanRecorder = void 0 : this.spans.push(t);
  }
}
class A {
  /**
   * @inheritDoc
   */
  __init2() {
    this.traceId = C();
  }
  /**
   * @inheritDoc
   */
  __init3() {
    this.spanId = C().substring(16);
  }
  /**
   * @inheritDoc
   */
  /**
   * Internal keeper of the status
   */
  /**
   * @inheritDoc
   */
  /**
   * Timestamp in seconds when the span was created.
   */
  __init4() {
    this.startTimestamp = St();
  }
  /**
   * Timestamp in seconds when the span ended.
   */
  /**
   * @inheritDoc
   */
  /**
   * @inheritDoc
   */
  /**
   * @inheritDoc
   */
  __init5() {
    this.tags = {};
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  __init6() {
    this.data = {};
  }
  /**
   * List of spans that were finalized
   */
  /**
   * @inheritDoc
   */
  /**
   * The instrumenter that created this span.
   */
  __init7() {
    this.instrumenter = "sentry";
  }
  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
  constructor(t) {
    if (A.prototype.__init2.call(this), A.prototype.__init3.call(this), A.prototype.__init4.call(this), A.prototype.__init5.call(this), A.prototype.__init6.call(this), A.prototype.__init7.call(this), !t)
      return this;
    t.traceId && (this.traceId = t.traceId), t.spanId && (this.spanId = t.spanId), t.parentSpanId && (this.parentSpanId = t.parentSpanId), "sampled" in t && (this.sampled = t.sampled), t.op && (this.op = t.op), t.description && (this.description = t.description), t.data && (this.data = t.data), t.tags && (this.tags = t.tags), t.status && (this.status = t.status), t.startTimestamp && (this.startTimestamp = t.startTimestamp), t.endTimestamp && (this.endTimestamp = t.endTimestamp), t.instrumenter && (this.instrumenter = t.instrumenter);
  }
  /**
   * @inheritDoc
   */
  startChild(t) {
    const n = new A({
      ...t,
      parentSpanId: this.spanId,
      sampled: this.sampled,
      traceId: this.traceId
    });
    if (n.spanRecorder = this.spanRecorder, n.spanRecorder && n.spanRecorder.add(n), n.transaction = this.transaction, (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && n.transaction) {
      const i = t && t.op || "< unknown op >", r = n.transaction.name || "< unknown name >", s = n.transaction.spanId, o = `[Tracing] Starting '${i}' span on transaction '${r}' (${s}).`;
      n.transaction.metadata.spanMetadata[n.spanId] = { logMessage: o }, f.log(o);
    }
    return n;
  }
  /**
   * @inheritDoc
   */
  setTag(t, n) {
    return this.tags = { ...this.tags, [t]: n }, this;
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  setData(t, n) {
    return this.data = { ...this.data, [t]: n }, this;
  }
  /**
   * @inheritDoc
   */
  setStatus(t) {
    return this.status = t, this;
  }
  /**
   * @inheritDoc
   */
  setHttpStatus(t) {
    this.setTag("http.status_code", String(t));
    const n = Br(t);
    return n !== "unknown_error" && this.setStatus(n), this;
  }
  /**
   * @inheritDoc
   */
  isSuccess() {
    return this.status === "ok";
  }
  /**
   * @inheritDoc
   */
  finish(t) {
    if ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && // Don't call this for transactions
    this.transaction && this.transaction.spanId !== this.spanId) {
      const { logMessage: n } = this.transaction.metadata.spanMetadata[this.spanId];
      n && f.log(n.replace("Starting", "Finishing"));
    }
    this.endTimestamp = typeof t == "number" ? t : St();
  }
  /**
   * @inheritDoc
   */
  toTraceparent() {
    let t = "";
    return this.sampled !== void 0 && (t = this.sampled ? "-1" : "-0"), `${this.traceId}-${this.spanId}${t}`;
  }
  /**
   * @inheritDoc
   */
  toContext() {
    return P({
      data: this.data,
      description: this.description,
      endTimestamp: this.endTimestamp,
      op: this.op,
      parentSpanId: this.parentSpanId,
      sampled: this.sampled,
      spanId: this.spanId,
      startTimestamp: this.startTimestamp,
      status: this.status,
      tags: this.tags,
      traceId: this.traceId
    });
  }
  /**
   * @inheritDoc
   */
  updateWithContext(t) {
    return this.data = t.data || {}, this.description = t.description, this.endTimestamp = t.endTimestamp, this.op = t.op, this.parentSpanId = t.parentSpanId, this.sampled = t.sampled, this.spanId = t.spanId || this.spanId, this.startTimestamp = t.startTimestamp || this.startTimestamp, this.status = t.status, this.tags = t.tags || {}, this.traceId = t.traceId || this.traceId, this;
  }
  /**
   * @inheritDoc
   */
  getTraceContext() {
    return P({
      data: Object.keys(this.data).length > 0 ? this.data : void 0,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : void 0,
      trace_id: this.traceId
    });
  }
  /**
   * @inheritDoc
   */
  toJSON() {
    return P({
      data: Object.keys(this.data).length > 0 ? this.data : void 0,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      start_timestamp: this.startTimestamp,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : void 0,
      timestamp: this.endTimestamp,
      trace_id: this.traceId
    });
  }
}
function Br(e) {
  if (e < 400 && e >= 100)
    return "ok";
  if (e >= 400 && e < 500)
    switch (e) {
      case 401:
        return "unauthenticated";
      case 403:
        return "permission_denied";
      case 404:
        return "not_found";
      case 409:
        return "already_exists";
      case 413:
        return "failed_precondition";
      case 429:
        return "resource_exhausted";
      default:
        return "invalid_argument";
    }
  if (e >= 500 && e < 600)
    switch (e) {
      case 501:
        return "unimplemented";
      case 503:
        return "unavailable";
      case 504:
        return "deadline_exceeded";
      default:
        return "internal_error";
    }
  return "unknown_error";
}
class tt extends A {
  /**
   * The reference to the current hub.
   */
  __init() {
    this._measurements = {};
  }
  __init2() {
    this._contexts = {};
  }
  __init3() {
    this._frozenDynamicSamplingContext = void 0;
  }
  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */
  constructor(t, n) {
    super(t), tt.prototype.__init.call(this), tt.prototype.__init2.call(this), tt.prototype.__init3.call(this), this._hub = n || E(), this._name = t.name || "", this.metadata = {
      source: "custom",
      ...t.metadata,
      spanMetadata: {}
    }, this._trimEnd = t.trimEnd, this.transaction = this;
    const i = this.metadata.dynamicSamplingContext;
    i && (this._frozenDynamicSamplingContext = { ...i });
  }
  /** Getter for `name` property */
  get name() {
    return this._name;
  }
  /** Setter for `name` property, which also sets `source` as custom */
  set name(t) {
    this.setName(t);
  }
  /**
   * JSDoc
   */
  setName(t, n = "custom") {
    this._name = t, this.metadata.source = n;
  }
  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */
  initSpanRecorder(t = 1e3) {
    this.spanRecorder || (this.spanRecorder = new Zt(t)), this.spanRecorder.add(this);
  }
  /**
   * @inheritDoc
   */
  setContext(t, n) {
    n === null ? delete this._contexts[t] : this._contexts[t] = n;
  }
  /**
   * @inheritDoc
   */
  setMeasurement(t, n, i = "") {
    this._measurements[t] = { value: n, unit: i };
  }
  /**
   * @inheritDoc
   */
  setMetadata(t) {
    this.metadata = { ...this.metadata, ...t };
  }
  /**
   * @inheritDoc
   */
  finish(t) {
    if (this.endTimestamp !== void 0)
      return;
    this.name || ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn("Transaction has no name, falling back to `<unlabeled transaction>`."), this.name = "<unlabeled transaction>"), super.finish(t);
    const n = this._hub.getClient();
    if (n && n.emit && n.emit("finishTransaction", this), this.sampled !== !0) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("[Tracing] Discarding transaction because its trace was not chosen to be sampled."), n && n.recordDroppedEvent("sample_rate", "transaction");
      return;
    }
    const i = this.spanRecorder ? this.spanRecorder.spans.filter((a) => a !== this && a.endTimestamp) : [];
    this._trimEnd && i.length > 0 && (this.endTimestamp = i.reduce((a, c) => a.endTimestamp && c.endTimestamp ? a.endTimestamp > c.endTimestamp ? a : c : a).endTimestamp);
    const r = this.metadata, s = {
      contexts: {
        ...this._contexts,
        // We don't want to override trace context
        trace: this.getTraceContext()
      },
      spans: i,
      start_timestamp: this.startTimestamp,
      tags: this.tags,
      timestamp: this.endTimestamp,
      transaction: this.name,
      type: "transaction",
      sdkProcessingMetadata: {
        ...r,
        dynamicSamplingContext: this.getDynamicSamplingContext()
      },
      ...r.source && {
        transaction_info: {
          source: r.source
        }
      }
    };
    return Object.keys(this._measurements).length > 0 && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log(
      "[Measurements] Adding measurements to transaction",
      JSON.stringify(this._measurements, void 0, 2)
    ), s.measurements = this._measurements), (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`), this._hub.captureEvent(s);
  }
  /**
   * @inheritDoc
   */
  toContext() {
    const t = super.toContext();
    return P({
      ...t,
      name: this.name,
      trimEnd: this._trimEnd
    });
  }
  /**
   * @inheritDoc
   */
  updateWithContext(t) {
    return super.updateWithContext(t), this.name = t.name || "", this._trimEnd = t.trimEnd, this;
  }
  /**
   * @inheritdoc
   *
   * @experimental
   */
  getDynamicSamplingContext() {
    if (this._frozenDynamicSamplingContext)
      return this._frozenDynamicSamplingContext;
    const t = this._hub || E(), n = t && t.getClient();
    if (!n)
      return {};
    const { environment: i, release: r } = n.getOptions() || {}, { publicKey: s } = n.getDsn() || {}, o = this.metadata.sampleRate, a = o !== void 0 ? o.toString() : void 0, { segment: c } = t.getScope().getUser() || {}, u = this.metadata.source, d = u && u !== "url" ? this.name : void 0, _ = P({
      environment: i || Be,
      release: r,
      transaction: d,
      user_segment: c,
      public_key: s,
      trace_id: this.traceId,
      sample_rate: a
    });
    return n.emit && n.emit("createDsc", _), _;
  }
  /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */
  setHub(t) {
    this._hub = t;
  }
}
const Bt = {
  idleTimeout: 1e3,
  finalTimeout: 3e4,
  heartbeatInterval: 5e3
}, Ar = "finishReason", Z = [
  "heartbeatFailed",
  "idleTimeout",
  "documentHidden",
  "finalTimeout",
  "externalFinish",
  "cancelled"
];
class Gr extends Zt {
  constructor(t, n, i, r) {
    super(r), this._pushActivity = t, this._popActivity = n, this.transactionSpanId = i;
  }
  /**
   * @inheritDoc
   */
  add(t) {
    t.spanId !== this.transactionSpanId && (t.finish = (n) => {
      t.endTimestamp = typeof n == "number" ? n : St(), this._popActivity(t.spanId);
    }, t.endTimestamp === void 0 && this._pushActivity(t.spanId)), super.add(t);
  }
}
class x extends tt {
  // Activities store a list of active spans
  __init() {
    this.activities = {};
  }
  // Track state of activities in previous heartbeat
  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
  __init2() {
    this._heartbeatCounter = 0;
  }
  // We should not use heartbeat if we finished a transaction
  __init3() {
    this._finished = !1;
  }
  // Idle timeout was canceled and we should finish the transaction with the last span end.
  __init4() {
    this._idleTimeoutCanceledPermanently = !1;
  }
  __init5() {
    this._beforeFinishCallbacks = [];
  }
  /**
   * Timer that tracks Transaction idleTimeout
   */
  __init6() {
    this._finishReason = Z[4];
  }
  constructor(t, n, i = Bt.idleTimeout, r = Bt.finalTimeout, s = Bt.heartbeatInterval, o = !1) {
    super(t, n), this._idleHub = n, this._idleTimeout = i, this._finalTimeout = r, this._heartbeatInterval = s, this._onScope = o, x.prototype.__init.call(this), x.prototype.__init2.call(this), x.prototype.__init3.call(this), x.prototype.__init4.call(this), x.prototype.__init5.call(this), x.prototype.__init6.call(this), o && (an(n), (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log(`Setting idle transaction on scope. Span ID: ${this.spanId}`), n.configureScope((a) => a.setSpan(this))), this._restartIdleTimeout(), setTimeout(() => {
      this._finished || (this.setStatus("deadline_exceeded"), this._finishReason = Z[3], this.finish());
    }, this._finalTimeout);
  }
  /** {@inheritDoc} */
  finish(t = St()) {
    if (this._finished = !0, this.activities = {}, this.op === "ui.action.click" && this.setTag(Ar, this._finishReason), this.spanRecorder) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("[Tracing] finishing IdleTransaction", new Date(t * 1e3).toISOString(), this.op);
      for (const n of this._beforeFinishCallbacks)
        n(this, t);
      this.spanRecorder.spans = this.spanRecorder.spans.filter((n) => {
        if (n.spanId === this.spanId)
          return !0;
        n.endTimestamp || (n.endTimestamp = t, n.setStatus("cancelled"), (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("[Tracing] cancelling span since transaction ended early", JSON.stringify(n, void 0, 2)));
        const i = n.startTimestamp < t;
        return i || (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log(
          "[Tracing] discarding Span since it happened after Transaction was finished",
          JSON.stringify(n, void 0, 2)
        ), i;
      }), (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("[Tracing] flushing IdleTransaction");
    } else
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("[Tracing] No active IdleTransaction");
    return this._onScope && an(this._idleHub), super.finish(t);
  }
  /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */
  registerBeforeFinishCallback(t) {
    this._beforeFinishCallbacks.push(t);
  }
  /**
   * @inheritDoc
   */
  initSpanRecorder(t) {
    if (!this.spanRecorder) {
      const n = (r) => {
        this._finished || this._pushActivity(r);
      }, i = (r) => {
        this._finished || this._popActivity(r);
      };
      this.spanRecorder = new Gr(n, i, this.spanId, t), (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("Starting heartbeat"), this._pingHeartbeat();
    }
    this.spanRecorder.add(this);
  }
  /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */
  cancelIdleTimeout(t, {
    restartOnChildSpanChange: n
  } = {
    restartOnChildSpanChange: !0
  }) {
    this._idleTimeoutCanceledPermanently = n === !1, this._idleTimeoutID && (clearTimeout(this._idleTimeoutID), this._idleTimeoutID = void 0, Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently && (this._finishReason = Z[5], this.finish(t)));
  }
  /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */
  _restartIdleTimeout(t) {
    this.cancelIdleTimeout(), this._idleTimeoutID = setTimeout(() => {
      !this._finished && Object.keys(this.activities).length === 0 && (this._finishReason = Z[1], this.finish(t));
    }, this._idleTimeout);
  }
  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
  _pushActivity(t) {
    this.cancelIdleTimeout(void 0, { restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently }), (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log(`[Tracing] pushActivity: ${t}`), this.activities[t] = !0, (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("[Tracing] new activities count", Object.keys(this.activities).length);
  }
  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
  _popActivity(t) {
    if (this.activities[t] && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log(`[Tracing] popActivity ${t}`), delete this.activities[t], (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("[Tracing] new activities count", Object.keys(this.activities).length)), Object.keys(this.activities).length === 0) {
      const n = St();
      this._idleTimeoutCanceledPermanently ? (this._finishReason = Z[5], this.finish(n)) : this._restartIdleTimeout(n + this._idleTimeout / 1e3);
    }
  }
  /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */
  _beat() {
    if (this._finished)
      return;
    const t = Object.keys(this.activities).join("");
    t === this._prevHeartbeatString ? this._heartbeatCounter++ : this._heartbeatCounter = 1, this._prevHeartbeatString = t, this._heartbeatCounter >= 3 ? ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("[Tracing] Transaction finished because of no change for 3 heart beats"), this.setStatus("deadline_exceeded"), this._finishReason = Z[0], this.finish()) : this._pingHeartbeat();
  }
  /**
   * Pings the heartbeat
   */
  _pingHeartbeat() {
    (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`), setTimeout(() => {
      this._beat();
    }, this._heartbeatInterval);
  }
}
function an(e) {
  const t = e.getScope();
  t.getTransaction() && t.setSpan(void 0);
}
function xr() {
  const t = this.getScope().getSpan();
  return t ? {
    "sentry-trace": t.toTraceparent()
  } : {};
}
function qn(e, t, n) {
  if (!Jt(t))
    return e.sampled = !1, e;
  if (e.sampled !== void 0)
    return e.setMetadata({
      sampleRate: Number(e.sampled)
    }), e;
  let i;
  return typeof t.tracesSampler == "function" ? (i = t.tracesSampler(n), e.setMetadata({
    sampleRate: Number(i)
  })) : n.parentSampled !== void 0 ? i = n.parentSampled : typeof t.tracesSampleRate < "u" ? (i = t.tracesSampleRate, e.setMetadata({
    sampleRate: Number(i)
  })) : (i = 1, e.setMetadata({
    sampleRate: i
  })), Yr(i) ? i ? (e.sampled = Math.random() < i, e.sampled ? ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log(`[Tracing] starting ${e.op} transaction - ${e.name}`), e) : ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log(
    `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
      i
    )})`
  ), e)) : ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log(
    `[Tracing] Discarding transaction because ${typeof t.tracesSampler == "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`
  ), e.sampled = !1, e) : ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn("[Tracing] Discarding transaction because of invalid sample rate."), e.sampled = !1, e);
}
function Yr(e) {
  return kn(e) || !(typeof e == "number" || typeof e == "boolean") ? ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn(
    `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
      e
    )} of type ${JSON.stringify(typeof e)}.`
  ), !1) : e < 0 || e > 1 ? ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${e}.`), !1) : !0;
}
function $r(e, t) {
  const n = this.getClient(), i = n && n.getOptions() || {}, r = i.instrumenter || "sentry", s = e.instrumenter || "sentry";
  r !== s && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.error(
    `A transaction was started with instrumenter=\`${s}\`, but the SDK is configured with the \`${r}\` instrumenter.
The transaction will not be sampled. Please use the ${r} instrumentation to start transactions.`
  ), e.sampled = !1);
  let o = new tt(e, this);
  return o = qn(o, i, {
    parentSampled: e.parentSampled,
    transactionContext: e,
    ...t
  }), o.sampled && o.initSpanRecorder(i._experiments && i._experiments.maxSpans), n && n.emit && n.emit("startTransaction", o), o;
}
function cn(e, t, n, i, r, s, o) {
  const a = e.getClient(), c = a && a.getOptions() || {};
  let u = new x(t, e, n, i, o, r);
  return u = qn(u, c, {
    parentSampled: t.parentSampled,
    transactionContext: t,
    ...s
  }), u.sampled && u.initSpanRecorder(c._experiments && c._experiments.maxSpans), a && a.emit && a.emit("startTransaction", u), u;
}
function Wn() {
  const e = ft();
  e.__SENTRY__ && (e.__SENTRY__.extensions = e.__SENTRY__.extensions || {}, e.__SENTRY__.extensions.startTransaction || (e.__SENTRY__.extensions.startTransaction = $r), e.__SENTRY__.extensions.traceHeaders || (e.__SENTRY__.extensions.traceHeaders = xr), Or());
}
function $e(e, t) {
  return E().captureException(e, { captureContext: t });
}
function zn(e) {
  E().configureScope(e);
}
function Pr(e) {
  E().withScope(e);
}
const Cr = "7";
function Mr(e) {
  const t = e.protocol ? `${e.protocol}:` : "", n = e.port ? `:${e.port}` : "";
  return `${t}//${e.host}${n}${e.path ? `/${e.path}` : ""}/api/`;
}
function Lr(e) {
  return `${Mr(e)}${e.projectId}/envelope/`;
}
function Fr(e, t) {
  return wi({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: e.publicKey,
    sentry_version: Cr,
    ...t && { sentry_client: `${t.name}/${t.version}` }
  });
}
function Hr(e, t = {}) {
  const n = typeof t == "string" ? t : t.tunnel, i = typeof t == "string" || !t._metadata ? void 0 : t._metadata.sdk;
  return n || `${Lr(e)}?${Fr(e, i)}`;
}
function jr(e, t) {
  return t && (e.sdk = e.sdk || {}, e.sdk.name = e.sdk.name || t.name, e.sdk.version = e.sdk.version || t.version, e.sdk.integrations = [...e.sdk.integrations || [], ...t.integrations || []], e.sdk.packages = [...e.sdk.packages || [], ...t.packages || []]), e;
}
function qr(e, t, n, i) {
  const r = Mn(n), s = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...r && { sdk: r },
    ...!!i && { dsn: we(t) }
  }, o = "aggregates" in e ? [{ type: "sessions" }, e] : [{ type: "session" }, e];
  return Kt(s, [o]);
}
function Wr(e, t, n, i) {
  const r = Mn(n), s = e.type && e.type !== "replay_event" ? e.type : "event";
  jr(e, n && n.sdk);
  const o = pr(e, r, i, t);
  return delete e.sdkProcessingMetadata, Kt(o, [[{ type: s }, e]]);
}
const un = [];
function zr(e) {
  const t = {};
  return e.forEach((n) => {
    const { name: i } = n, r = t[i];
    r && !r.isDefaultInstance && n.isDefaultInstance || (t[i] = n);
  }), Object.keys(t).map((n) => t[n]);
}
function Vr(e) {
  const t = e.defaultIntegrations || [], n = e.integrations;
  t.forEach((o) => {
    o.isDefaultInstance = !0;
  });
  let i;
  Array.isArray(n) ? i = [...t, ...n] : typeof n == "function" ? i = yt(n(t)) : i = t;
  const r = zr(i), s = Kr(r, (o) => o.name === "Debug");
  if (s !== -1) {
    const [o] = r.splice(s, 1);
    r.push(o);
  }
  return r;
}
function Xr(e) {
  const t = {};
  return e.forEach((n) => {
    n && Vn(n, t);
  }), t;
}
function Vn(e, t) {
  t[e.name] = e, un.indexOf(e.name) === -1 && (e.setupOnce(Ae, E), un.push(e.name), (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log(`Integration installed: ${e.name}`));
}
function Kr(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]) === !0)
      return n;
  return -1;
}
function Jr(e, t, n, i) {
  const { normalizeDepth: r = 3, normalizeMaxBreadth: s = 1e3 } = e, o = {
    ...t,
    event_id: t.event_id || n.event_id || C(),
    timestamp: t.timestamp || Vt()
  }, a = n.integrations || e.integrations.map((d) => d.name);
  Qr(o, e), ts(o, a), Zr(o, e.stackParser);
  let c = i;
  n.captureContext && (c = M.clone(c).update(n.captureContext));
  let u = X(o);
  if (c) {
    if (c.getAttachments) {
      const d = [...n.attachments || [], ...c.getAttachments()];
      d.length && (n.attachments = d);
    }
    u = c.applyToEvent(o, n);
  }
  return u.then((d) => typeof r == "number" && r > 0 ? es(d, r, s) : d);
}
function Qr(e, t) {
  const { environment: n, release: i, dist: r, maxValueLength: s = 250 } = t;
  "environment" in e || (e.environment = "environment" in t ? n : Be), e.release === void 0 && i !== void 0 && (e.release = i), e.dist === void 0 && r !== void 0 && (e.dist = r), e.message && (e.message = pt(e.message, s));
  const o = e.exception && e.exception.values && e.exception.values[0];
  o && o.value && (o.value = pt(o.value, s));
  const a = e.request;
  a && a.url && (a.url = pt(a.url, s));
}
function Zr(e, t) {
  const n = I._sentryDebugIds;
  if (!n)
    return;
  const i = Object.keys(n).reduce((o, a) => {
    const c = t(a);
    for (const u of c)
      if (u.abs_path) {
        o[u.abs_path] = n[a];
        break;
      }
    return o;
  }, {}), r = /* @__PURE__ */ new Set();
  try {
    e.exception.values.forEach((o) => {
      o.stacktrace.frames.forEach((a) => {
        a.abs_path && r.add(a.abs_path);
      });
    });
  } catch {
  }
  e.debug_meta = e.debug_meta || {}, e.debug_meta.images = e.debug_meta.images || [];
  const s = e.debug_meta.images;
  r.forEach((o) => {
    i[o] && s.push({
      type: "sourcemap",
      code_file: o,
      debug_id: i[o]
    });
  });
}
function ts(e, t) {
  t.length > 0 && (e.sdk = e.sdk || {}, e.sdk.integrations = [...e.sdk.integrations || [], ...t]);
}
function es(e, t, n) {
  if (!e)
    return null;
  const i = {
    ...e,
    ...e.breadcrumbs && {
      breadcrumbs: e.breadcrumbs.map((r) => ({
        ...r,
        ...r.data && {
          data: G(r.data, t, n)
        }
      }))
    },
    ...e.user && {
      user: G(e.user, t, n)
    },
    ...e.contexts && {
      contexts: G(e.contexts, t, n)
    },
    ...e.extra && {
      extra: G(e.extra, t, n)
    }
  };
  return e.contexts && e.contexts.trace && i.contexts && (i.contexts.trace = e.contexts.trace, e.contexts.trace.data && (i.contexts.trace.data = G(e.contexts.trace.data, t, n))), e.spans && (i.spans = e.spans.map((r) => (r.data && (r.data = G(r.data, t, n)), r))), i;
}
const _n = "Not capturing exception because it's already been captured.";
class q {
  /** Options passed to the SDK. */
  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */
  /** Array of set up integrations. */
  __init() {
    this._integrations = {};
  }
  /** Indicates whether this client's integrations have been set up. */
  __init2() {
    this._integrationsInitialized = !1;
  }
  /** Number of calls being processed */
  __init3() {
    this._numProcessing = 0;
  }
  /** Holds flushable  */
  __init4() {
    this._outcomes = {};
  }
  // eslint-disable-next-line @typescript-eslint/ban-types
  __init5() {
    this._hooks = {};
  }
  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  constructor(t) {
    if (q.prototype.__init.call(this), q.prototype.__init2.call(this), q.prototype.__init3.call(this), q.prototype.__init4.call(this), q.prototype.__init5.call(this), this._options = t, t.dsn) {
      this._dsn = Di(t.dsn);
      const n = Hr(this._dsn, t);
      this._transport = t.transport({
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...t.transportOptions,
        url: n
      });
    } else
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn("No DSN provided, client will not do anything.");
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  captureException(t, n, i) {
    if (Ze(t)) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log(_n);
      return;
    }
    let r = n && n.event_id;
    return this._process(
      this.eventFromException(t, n).then((s) => this._captureEvent(s, n, i)).then((s) => {
        r = s;
      })
    ), r;
  }
  /**
   * @inheritDoc
   */
  captureMessage(t, n, i, r) {
    let s = i && i.event_id;
    const o = In(t) ? this.eventFromMessage(String(t), n, i) : this.eventFromException(t, i);
    return this._process(
      o.then((a) => this._captureEvent(a, i, r)).then((a) => {
        s = a;
      })
    ), s;
  }
  /**
   * @inheritDoc
   */
  captureEvent(t, n, i) {
    if (n && n.originalException && Ze(n.originalException)) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log(_n);
      return;
    }
    let r = n && n.event_id;
    return this._process(
      this._captureEvent(t, n, i).then((s) => {
        r = s;
      })
    ), r;
  }
  /**
   * @inheritDoc
   */
  captureSession(t) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn("SDK not enabled, will not capture session.");
      return;
    }
    typeof t.release != "string" ? (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn("Discarded session because of missing or non-string release") : (this.sendSession(t), ct(t, { init: !1 }));
  }
  /**
   * @inheritDoc
   */
  getDsn() {
    return this._dsn;
  }
  /**
   * @inheritDoc
   */
  getOptions() {
    return this._options;
  }
  /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */
  getSdkMetadata() {
    return this._options._metadata;
  }
  /**
   * @inheritDoc
   */
  getTransport() {
    return this._transport;
  }
  /**
   * @inheritDoc
   */
  flush(t) {
    const n = this._transport;
    return n ? this._isClientDoneProcessing(t).then((i) => n.flush(t).then((r) => i && r)) : X(!0);
  }
  /**
   * @inheritDoc
   */
  close(t) {
    return this.flush(t).then((n) => (this.getOptions().enabled = !1, n));
  }
  /**
   * Sets up the integrations
   */
  setupIntegrations() {
    this._isEnabled() && !this._integrationsInitialized && (this._integrations = Xr(this._options.integrations), this._integrationsInitialized = !0);
  }
  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */
  getIntegrationById(t) {
    return this._integrations[t];
  }
  /**
   * @inheritDoc
   */
  getIntegration(t) {
    try {
      return this._integrations[t.id] || null;
    } catch {
      return (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn(`Cannot retrieve integration ${t.id} from the current Client`), null;
    }
  }
  /**
   * @inheritDoc
   */
  addIntegration(t) {
    Vn(t, this._integrations);
  }
  /**
   * @inheritDoc
   */
  sendEvent(t, n = {}) {
    if (this._dsn) {
      let i = Wr(t, this._dsn, this._options._metadata, this._options.tunnel);
      for (const s of n.attachments || [])
        i = ur(
          i,
          fr(
            s,
            this._options.transportOptions && this._options.transportOptions.textEncoder
          )
        );
      const r = this._sendEnvelope(i);
      r && r.then((s) => this.emit("afterSendEvent", t, s), null);
    }
  }
  /**
   * @inheritDoc
   */
  sendSession(t) {
    if (this._dsn) {
      const n = qr(t, this._dsn, this._options._metadata, this._options.tunnel);
      this._sendEnvelope(n);
    }
  }
  /**
   * @inheritDoc
   */
  recordDroppedEvent(t, n, i) {
    if (this._options.sendClientReports) {
      const r = `${t}:${n}`;
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log(`Adding outcome: "${r}"`), this._outcomes[r] = this._outcomes[r] + 1 || 1;
    }
  }
  // Keep on() & emit() signatures in sync with types' client.ts interface
  /** @inheritdoc */
  /** @inheritdoc */
  on(t, n) {
    this._hooks[t] || (this._hooks[t] = []), this._hooks[t].push(n);
  }
  /** @inheritdoc */
  /** @inheritdoc */
  emit(t, ...n) {
    this._hooks[t] && this._hooks[t].forEach((i) => i(...n));
  }
  /** Updates existing session based on the provided event */
  _updateSessionFromEvent(t, n) {
    let i = !1, r = !1;
    const s = n.exception && n.exception.values;
    if (s) {
      r = !0;
      for (const c of s) {
        const u = c.mechanism;
        if (u && u.handled === !1) {
          i = !0;
          break;
        }
      }
    }
    const o = t.status === "ok";
    (o && t.errors === 0 || o && i) && (ct(t, {
      ...i && { status: "crashed" },
      errors: t.errors || Number(r || i)
    }), this.captureSession(t));
  }
  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
  _isClientDoneProcessing(t) {
    return new D((n) => {
      let i = 0;
      const r = 1, s = setInterval(() => {
        this._numProcessing == 0 ? (clearInterval(s), n(!0)) : (i += r, t && i >= t && (clearInterval(s), n(!1)));
      }, r);
    });
  }
  /** Determines whether this SDK is enabled and a valid Dsn is present. */
  _isEnabled() {
    return this.getOptions().enabled !== !1 && this._dsn !== void 0;
  }
  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
  _prepareEvent(t, n, i) {
    const r = this.getOptions(), s = Object.keys(this._integrations);
    return !n.integrations && s.length > 0 && (n.integrations = s), Jr(r, t, n, i);
  }
  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
  _captureEvent(t, n = {}, i) {
    return this._processEvent(t, n, i).then(
      (r) => r.event_id,
      (r) => {
        if (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) {
          const s = r;
          s.logLevel === "log" ? f.log(s.message) : f.warn(s);
        }
      }
    );
  }
  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
  _processEvent(t, n, i) {
    const r = this.getOptions(), { sampleRate: s } = r;
    if (!this._isEnabled())
      return xt(new N("SDK not enabled, will not capture event.", "log"));
    const o = Kn(t), a = Xn(t), c = t.type || "error", u = `before send for type \`${c}\``;
    if (a && typeof s == "number" && Math.random() > s)
      return this.recordDroppedEvent("sample_rate", "error", t), xt(
        new N(
          `Discarding event because it's not included in the random sample (sampling rate = ${s})`,
          "log"
        )
      );
    const d = c === "replay_event" ? "replay" : c;
    return this._prepareEvent(t, n, i).then((_) => {
      if (_ === null)
        throw this.recordDroppedEvent("event_processor", d, t), new N("An event processor returned `null`, will not send event.", "log");
      if (n.data && n.data.__sentry__ === !0)
        return _;
      const l = is(r, _, n);
      return ns(l, u);
    }).then((_) => {
      if (_ === null)
        throw this.recordDroppedEvent("before_send", d, t), new N(`${u} returned \`null\`, will not send event.`, "log");
      const p = i && i.getSession();
      !o && p && this._updateSessionFromEvent(p, _);
      const l = _.transaction_info;
      if (o && l && _.transaction !== t.transaction) {
        const m = "custom";
        _.transaction_info = {
          ...l,
          source: m
        };
      }
      return this.sendEvent(_, n), _;
    }).then(null, (_) => {
      throw _ instanceof N ? _ : (this.captureException(_, {
        data: {
          __sentry__: !0
        },
        originalException: _
      }), new N(
        `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${_}`
      ));
    });
  }
  /**
   * Occupies the client with processing and event
   */
  _process(t) {
    this._numProcessing++, t.then(
      (n) => (this._numProcessing--, n),
      (n) => (this._numProcessing--, n)
    );
  }
  /**
   * @inheritdoc
   */
  _sendEnvelope(t) {
    if (this._transport && this._dsn)
      return this.emit("beforeEnvelope", t), this._transport.send(t).then(null, (n) => {
        (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.error("Error while sending event:", n);
      });
    (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.error("Transport disabled");
  }
  /**
   * Clears outcomes on this client and returns them.
   */
  _clearOutcomes() {
    const t = this._outcomes;
    return this._outcomes = {}, Object.keys(t).map((n) => {
      const [i, r] = n.split(":");
      return {
        reason: i,
        category: r,
        quantity: t[n]
      };
    });
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
}
function ns(e, t) {
  const n = `${t} must return \`null\` or a valid event.`;
  if (j(e))
    return e.then(
      (i) => {
        if (!st(i) && i !== null)
          throw new N(n);
        return i;
      },
      (i) => {
        throw new N(`${t} rejected with ${i}`);
      }
    );
  if (!st(e) && e !== null)
    throw new N(n);
  return e;
}
function is(e, t, n) {
  const { beforeSend: i, beforeSendTransaction: r } = e;
  return Xn(t) && i ? i(t, n) : Kn(t) && r ? r(t, n) : t;
}
function Xn(e) {
  return e.type === void 0;
}
function Kn(e) {
  return e.type === "transaction";
}
function rs(e, t) {
  t.debug === !0 && (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__ ? f.enable() : console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle."));
  const n = E();
  n.getScope().update(t.initialScope);
  const r = new e(t);
  n.bindClient(r);
}
const ss = 30;
function Jn(e, t, n = tr(
  e.bufferSize || ss
)) {
  let i = {};
  const r = (o) => n.drain(o);
  function s(o) {
    const a = [];
    if (en(o, (_, p) => {
      const l = nn(p);
      if (yr(i, l)) {
        const m = dn(_, p);
        e.recordDroppedEvent("ratelimit_backoff", l, m);
      } else
        a.push(_);
    }), a.length === 0)
      return X();
    const c = Kt(o[0], a), u = (_) => {
      en(c, (p, l) => {
        const m = dn(p, l);
        e.recordDroppedEvent(_, nn(l), m);
      });
    }, d = () => t({ body: _r(c, e.textEncoder) }).then(
      (_) => (_.statusCode !== void 0 && (_.statusCode < 200 || _.statusCode >= 300) && (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn(`Sentry responded with status code ${_.statusCode} to sent event.`), i = Sr(i, _), _),
      (_) => {
        throw u("network_error"), _;
      }
    );
    return n.add(d).then(
      (_) => _,
      (_) => {
        if (_ instanceof N)
          return (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.error("Skipped sending event because buffer is full."), u("queue_overflow"), X();
        throw _;
      }
    );
  }
  return s.__sentry__baseTransport__ = !0, {
    send: s,
    flush: r
  };
}
function dn(e, t) {
  if (!(t !== "event" && t !== "transaction"))
    return Array.isArray(e) ? e[1] : void 0;
}
const $t = "7.45.0";
let fn;
class Tt {
  constructor() {
    Tt.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "FunctionToString";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = Tt.id;
  }
  /**
   * @inheritDoc
   */
  setupOnce() {
    fn = Function.prototype.toString, Function.prototype.toString = function(...t) {
      const n = Ue(this) || this;
      return fn.apply(n, t);
    };
  }
}
Tt.__initStatic();
const os = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
class et {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "InboundFilters";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = et.id;
  }
  constructor(t = {}) {
    this._options = t, et.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */
  setupOnce(t, n) {
    const i = (r) => {
      const s = n();
      if (s) {
        const o = s.getIntegration(et);
        if (o) {
          const a = s.getClient(), c = a ? a.getOptions() : {}, u = as(o._options, c);
          return cs(r, u) ? null : r;
        }
      }
      return r;
    };
    i.id = this.name, t(i);
  }
}
et.__initStatic();
function as(e = {}, t = {}) {
  return {
    allowUrls: [...e.allowUrls || [], ...t.allowUrls || []],
    denyUrls: [...e.denyUrls || [], ...t.denyUrls || []],
    ignoreErrors: [
      ...e.ignoreErrors || [],
      ...t.ignoreErrors || [],
      ...os
    ],
    ignoreInternal: e.ignoreInternal !== void 0 ? e.ignoreInternal : !0
  };
}
function cs(e, t) {
  return t.ignoreInternal && ls(e) ? ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn(`Event dropped due to being internal Sentry Error.
Event: ${z(e)}`), !0) : us(e, t.ignoreErrors) ? ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn(
    `Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${z(e)}`
  ), !0) : _s(e, t.denyUrls) ? ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn(
    `Event dropped due to being matched by \`denyUrls\` option.
Event: ${z(
      e
    )}.
Url: ${Pt(e)}`
  ), !0) : ds(e, t.allowUrls) ? !1 : ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn(
    `Event dropped due to not being matched by \`allowUrls\` option.
Event: ${z(
      e
    )}.
Url: ${Pt(e)}`
  ), !0);
}
function us(e, t) {
  return e.type || !t || !t.length ? !1 : fs(e).some((n) => zt(n, t));
}
function _s(e, t) {
  if (!t || !t.length)
    return !1;
  const n = Pt(e);
  return n ? zt(n, t) : !1;
}
function ds(e, t) {
  if (!t || !t.length)
    return !0;
  const n = Pt(e);
  return n ? zt(n, t) : !0;
}
function fs(e) {
  if (e.message)
    return [e.message];
  if (e.exception)
    try {
      const { type: t = "", value: n = "" } = e.exception.values && e.exception.values[0] || {};
      return [`${n}`, `${t}: ${n}`];
    } catch {
      return (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.error(`Cannot extract message for event ${z(e)}`), [];
    }
  return [];
}
function ls(e) {
  try {
    return e.exception.values[0].type === "SentryError";
  } catch {
  }
  return !1;
}
function ps(e = []) {
  for (let t = e.length - 1; t >= 0; t--) {
    const n = e[t];
    if (n && n.filename !== "<anonymous>" && n.filename !== "[native code]")
      return n.filename || null;
  }
  return null;
}
function Pt(e) {
  try {
    let t;
    try {
      t = e.exception.values[0].stacktrace.frames;
    } catch {
    }
    return t ? ps(t) : null;
  } catch {
    return (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.error(`Cannot extract url for event ${z(e)}`), null;
  }
}
const g = I;
let Se = 0;
function Qn() {
  return Se > 0;
}
function hs() {
  Se++, setTimeout(() => {
    Se--;
  });
}
function ut(e, t = {}, n) {
  if (typeof e != "function")
    return e;
  try {
    const r = e.__sentry_wrapped__;
    if (r)
      return r;
    if (Ue(e))
      return e;
  } catch {
    return e;
  }
  const i = function() {
    const r = Array.prototype.slice.call(arguments);
    try {
      n && typeof n == "function" && n.apply(this, arguments);
      const s = r.map((o) => ut(o, t));
      return e.apply(this, s);
    } catch (s) {
      throw hs(), Pr((o) => {
        o.addEventProcessor((a) => (t.mechanism && (pe(a, void 0, void 0), Et(a, t.mechanism)), a.extra = {
          ...a.extra,
          arguments: r
        }, a)), $e(s);
      }), s;
    }
  };
  try {
    for (const r in e)
      Object.prototype.hasOwnProperty.call(e, r) && (i[r] = e[r]);
  } catch {
  }
  Bn(i, e), ke(e, "__sentry_wrapped__", i);
  try {
    Object.getOwnPropertyDescriptor(i, "name").configurable && Object.defineProperty(i, "name", {
      get() {
        return e.name;
      }
    });
  } catch {
  }
  return i;
}
function Zn(e, t) {
  const n = Pe(e, t), i = {
    type: t && t.name,
    value: ys(t)
  };
  return n.length && (i.stacktrace = { frames: n }), i.type === void 0 && i.value === "" && (i.value = "Unrecoverable error caught"), i;
}
function ms(e, t, n, i) {
  const s = E().getClient(), o = s && s.getOptions().normalizeDepth, a = {
    exception: {
      values: [
        {
          type: ve(t) ? t.constructor.name : i ? "UnhandledRejection" : "Error",
          value: `Non-Error ${i ? "promise rejection" : "exception"} captured with keys: ${ki(t)}`
        }
      ]
    },
    extra: {
      __serialized__: Pn(t, o)
    }
  };
  if (n) {
    const c = Pe(e, n);
    c.length && (a.exception.values[0].stacktrace = { frames: c });
  }
  return a;
}
function ue(e, t) {
  return {
    exception: {
      values: [Zn(e, t)]
    }
  };
}
function Pe(e, t) {
  const n = t.stacktrace || t.stack || "", i = Es(t);
  try {
    return e(n, i);
  } catch {
  }
  return [];
}
const gs = /Minified React error #\d+;/i;
function Es(e) {
  if (e) {
    if (typeof e.framesToPop == "number")
      return e.framesToPop;
    if (gs.test(e.message))
      return 1;
  }
  return 0;
}
function ys(e) {
  const t = e && e.message;
  return t ? t.error && typeof t.error.message == "string" ? t.error.message : t : "No error message";
}
function Ss(e, t, n, i) {
  const r = n && n.syntheticException || void 0, s = Ce(e, t, r, i);
  return Et(s), s.level = "error", n && n.event_id && (s.event_id = n.event_id), X(s);
}
function Ts(e, t, n = "info", i, r) {
  const s = i && i.syntheticException || void 0, o = Te(e, t, s, r);
  return o.level = n, i && i.event_id && (o.event_id = i.event_id), X(o);
}
function Ce(e, t, n, i, r) {
  let s;
  if (vn(t) && t.error)
    return ue(e, t.error);
  if (qe(t) || pi(t)) {
    const o = t;
    if ("stack" in t)
      s = ue(e, t);
    else {
      const a = o.name || (qe(o) ? "DOMError" : "DOMException"), c = o.message ? `${a}: ${o.message}` : a;
      s = Te(e, c, n, i), pe(s, c);
    }
    return "code" in o && (s.tags = { ...s.tags, "DOMException.code": `${o.code}` }), s;
  }
  return Dn(t) ? ue(e, t) : st(t) || ve(t) ? (s = ms(e, t, n, r), Et(s, {
    synthetic: !0
  }), s) : (s = Te(e, t, n, i), pe(s, `${t}`, void 0), Et(s, {
    synthetic: !0
  }), s);
}
function Te(e, t, n, i) {
  const r = {
    message: t
  };
  if (i && n) {
    const s = Pe(e, n);
    s.length && (r.exception = {
      values: [{ value: t, stacktrace: { frames: s } }]
    });
  }
  return r;
}
const kt = 1024, ti = "Breadcrumbs";
class Rt {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = ti;
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = Rt.id;
  }
  /**
   * Options of the breadcrumbs integration.
   */
  // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.
  /**
   * @inheritDoc
   */
  constructor(t) {
    Rt.prototype.__init.call(this), this.options = {
      console: !0,
      dom: !0,
      fetch: !0,
      history: !0,
      sentry: !0,
      xhr: !0,
      ...t
    };
  }
  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */
  setupOnce() {
    this.options.console && w("console", bs), this.options.dom && w("dom", Rs(this.options.dom)), this.options.xhr && w("xhr", Ns), this.options.fetch && w("fetch", Ds), this.options.history && w("history", vs);
  }
  /**
   * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
   */
  addSentryBreadcrumb(t) {
    this.options.sentry && E().addBreadcrumb(
      {
        category: `sentry.${t.type === "transaction" ? "transaction" : "event"}`,
        event_id: t.event_id,
        level: t.level,
        message: z(t)
      },
      {
        event: t
      }
    );
  }
}
Rt.__initStatic();
function Rs(e) {
  function t(n) {
    let i, r = typeof e == "object" ? e.serializeAttribute : void 0, s = typeof e == "object" && typeof e.maxStringLength == "number" ? e.maxStringLength : void 0;
    s && s > kt && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn(
      `\`dom.maxStringLength\` cannot exceed ${kt}, but a value of ${s} was configured. Sentry will use ${kt} instead.`
    ), s = kt), typeof r == "string" && (r = [r]);
    try {
      const o = n.event;
      i = Is(o) ? ot(o.target, { keyAttrs: r, maxStringLength: s }) : ot(o, { keyAttrs: r, maxStringLength: s });
    } catch {
      i = "<unknown>";
    }
    i.length !== 0 && E().addBreadcrumb(
      {
        category: `ui.${n.name}`,
        message: i
      },
      {
        event: n.event,
        name: n.name,
        global: n.global
      }
    );
  }
  return t;
}
function bs(e) {
  for (let n = 0; n < e.args.length; n++)
    if (e.args[n] === "ref=Ref<") {
      e.args[n + 1] = "viewRef";
      break;
    }
  const t = {
    category: "console",
    data: {
      arguments: e.args,
      logger: "console"
    },
    level: rr(e.level),
    message: ze(e.args, " ")
  };
  if (e.level === "assert")
    if (e.args[0] === !1)
      t.message = `Assertion failed: ${ze(e.args.slice(1), " ") || "console.assert"}`, t.data.arguments = e.args.slice(1);
    else
      return;
  E().addBreadcrumb(t, {
    input: e.args,
    level: e.level
  });
}
function Ns(e) {
  const { startTimestamp: t, endTimestamp: n } = e;
  if (!t || !n || !e.xhr.__sentry_xhr__)
    return;
  const { method: i, url: r, status_code: s, body: o } = e.xhr.__sentry_xhr__, a = {
    method: i,
    url: r,
    status_code: s
  }, c = {
    xhr: e.xhr,
    input: o,
    startTimestamp: t,
    endTimestamp: n
  };
  E().addBreadcrumb(
    {
      category: "xhr",
      data: a,
      type: "http"
    },
    c
  );
}
function Ds(e) {
  const { startTimestamp: t, endTimestamp: n } = e;
  if (n && !(e.fetchData.url.match(/sentry_key/) && e.fetchData.method === "POST"))
    if (e.error) {
      const i = e.fetchData, r = {
        data: e.error,
        input: e.args,
        startTimestamp: t,
        endTimestamp: n
      };
      E().addBreadcrumb(
        {
          category: "fetch",
          data: i,
          level: "error",
          type: "http"
        },
        r
      );
    } else {
      const i = {
        ...e.fetchData,
        status_code: e.response && e.response.status
      }, r = {
        input: e.args,
        response: e.response,
        startTimestamp: t,
        endTimestamp: n
      };
      E().addBreadcrumb(
        {
          category: "fetch",
          data: i,
          type: "http"
        },
        r
      );
    }
}
function vs(e) {
  let t = e.from, n = e.to;
  const i = ae(g.location.href);
  let r = ae(t);
  const s = ae(n);
  r.path || (r = i), i.protocol === s.protocol && i.host === s.host && (n = s.relative), i.protocol === r.protocol && i.host === r.host && (t = r.relative), E().addBreadcrumb({
    category: "navigation",
    data: {
      from: t,
      to: n
    }
  });
}
function Is(e) {
  return e && !!e.target;
}
class ws extends q {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  constructor(t) {
    const n = g.SENTRY_SDK_SOURCE || Xi();
    t._metadata = t._metadata || {}, t._metadata.sdk = t._metadata.sdk || {
      name: "sentry.javascript.browser",
      packages: [
        {
          name: `${n}:@sentry/browser`,
          version: $t
        }
      ],
      version: $t
    }, super(t), t.sendClientReports && g.document && g.document.addEventListener("visibilitychange", () => {
      g.document.visibilityState === "hidden" && this._flushOutcomes();
    });
  }
  /**
   * @inheritDoc
   */
  eventFromException(t, n) {
    return Ss(this._options.stackParser, t, n, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  eventFromMessage(t, n = "info", i) {
    return Ts(this._options.stackParser, t, n, i, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  sendEvent(t, n) {
    const i = this.getIntegrationById(ti);
    i && i.addSentryBreadcrumb && i.addSentryBreadcrumb(t), super.sendEvent(t, n);
  }
  /**
   * @inheritDoc
   */
  _prepareEvent(t, n, i) {
    return t.platform = t.platform || "javascript", super._prepareEvent(t, n, i);
  }
  /**
   * Sends client reports as an envelope.
   */
  _flushOutcomes() {
    const t = this._clearOutcomes();
    if (t.length === 0) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("No outcomes to send");
      return;
    }
    if (!this._dsn) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("No dsn provided, will not send outcomes");
      return;
    }
    (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("Sending outcomes:", t);
    const n = hr(t, this._options.tunnel && we(this._dsn));
    this._sendEnvelope(n);
  }
}
let lt;
function ks() {
  if (lt)
    return lt;
  if (le(g.fetch))
    return lt = g.fetch.bind(g);
  const e = g.document;
  let t = g.fetch;
  if (e && typeof e.createElement == "function")
    try {
      const n = e.createElement("iframe");
      n.hidden = !0, e.head.appendChild(n);
      const i = n.contentWindow;
      i && i.fetch && (t = i.fetch), e.head.removeChild(n);
    } catch (n) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", n);
    }
  return lt = t.bind(g);
}
function Us() {
  lt = void 0;
}
function Os(e, t = ks()) {
  let n = 0, i = 0;
  function r(s) {
    const o = s.body.length;
    n += o, i++;
    const a = {
      body: s.body,
      method: "POST",
      referrerPolicy: "origin",
      headers: e.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: n <= 6e4 && i < 15,
      ...e.fetchOptions
    };
    try {
      return t(e.url, a).then((c) => (n -= o, i--, {
        statusCode: c.status,
        headers: {
          "x-sentry-rate-limits": c.headers.get("X-Sentry-Rate-Limits"),
          "retry-after": c.headers.get("Retry-After")
        }
      }));
    } catch (c) {
      return Us(), n -= o, i--, xt(c);
    }
  }
  return Jn(e, r);
}
const Bs = 4;
function As(e) {
  function t(n) {
    return new D((i, r) => {
      const s = new XMLHttpRequest();
      s.onerror = r, s.onreadystatechange = () => {
        s.readyState === Bs && i({
          statusCode: s.status,
          headers: {
            "x-sentry-rate-limits": s.getResponseHeader("X-Sentry-Rate-Limits"),
            "retry-after": s.getResponseHeader("Retry-After")
          }
        });
      }, s.open("POST", e.url);
      for (const o in e.headers)
        Object.prototype.hasOwnProperty.call(e.headers, o) && s.setRequestHeader(o, e.headers[o]);
      s.send(n.body);
    });
  }
  return Jn(e, t);
}
const te = "?", Gs = 30, xs = 40, Ys = 50;
function Me(e, t, n, i) {
  const r = {
    filename: e,
    abs_path: e,
    // As opposed to filename, abs_path is immutable (I can't control your actions but don't touch it!)
    function: t,
    in_app: !0
    // All browser frames are considered in_app
  };
  return n !== void 0 && (r.lineno = n), i !== void 0 && (r.colno = i), r;
}
const $s = /^\s*at (?:(.*\).*?|.*?) ?\((?:address at )?)?(?:async )?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, Ps = /\((\S*)(?::(\d+))(?::(\d+))\)/, Cs = (e) => {
  const t = $s.exec(e);
  if (t) {
    if (t[2] && t[2].indexOf("eval") === 0) {
      const s = Ps.exec(t[2]);
      s && (t[2] = s[1], t[3] = s[2], t[4] = s[3]);
    }
    const [i, r] = ei(t[1] || te, t[2]);
    return Me(r, i, t[3] ? +t[3] : void 0, t[4] ? +t[4] : void 0);
  }
}, Ms = [Gs, Cs], Ls = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|safari-extension|safari-web-extension|capacitor)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, Fs = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, Hs = (e) => {
  const t = Ls.exec(e);
  if (t) {
    if (t[3] && t[3].indexOf(" > eval") > -1) {
      const s = Fs.exec(t[3]);
      s && (t[1] = t[1] || "eval", t[3] = s[1], t[4] = s[2], t[5] = "");
    }
    let i = t[3], r = t[1] || te;
    return [r, i] = ei(r, i), Me(i, r, t[4] ? +t[4] : void 0, t[5] ? +t[5] : void 0);
  }
}, js = [Ys, Hs], qs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i, Ws = (e) => {
  const t = qs.exec(e);
  return t ? Me(t[2], t[1] || te, +t[3], t[4] ? +t[4] : void 0) : void 0;
}, zs = [xs, Ws], Vs = [Ms, js, zs], Xs = xn(...Vs), ei = (e, t) => {
  const n = e.indexOf("safari-extension") !== -1, i = e.indexOf("safari-web-extension") !== -1;
  return n || i ? [
    e.indexOf("@") !== -1 ? e.split("@")[0] : te,
    n ? `safari-extension:${t}` : `safari-web-extension:${t}`
  ] : [e, t];
};
class L {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "GlobalHandlers";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = L.id;
  }
  /** JSDoc */
  /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */
  __init2() {
    this._installFunc = {
      onerror: Ks,
      onunhandledrejection: Js
    };
  }
  /** JSDoc */
  constructor(t) {
    L.prototype.__init.call(this), L.prototype.__init2.call(this), this._options = {
      onerror: !0,
      onunhandledrejection: !0,
      ...t
    };
  }
  /**
   * @inheritDoc
   */
  setupOnce() {
    Error.stackTraceLimit = 50;
    const t = this._options;
    for (const n in t) {
      const i = this._installFunc[n];
      i && t[n] && (to(n), i(), this._installFunc[n] = void 0);
    }
  }
}
L.__initStatic();
function Ks() {
  w(
    "error",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e) => {
      const [t, n, i] = ri();
      if (!t.getIntegration(L))
        return;
      const { msg: r, url: s, line: o, column: a, error: c } = e;
      if (Qn() || c && c.__sentry_own_request__)
        return;
      const u = c === void 0 && F(r) ? Zs(r, s, o, a) : ni(
        Ce(n, c || r, void 0, i, !1),
        s,
        o,
        a
      );
      u.level = "error", ii(t, c, u, "onerror");
    }
  );
}
function Js() {
  w(
    "unhandledrejection",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e) => {
      const [t, n, i] = ri();
      if (!t.getIntegration(L))
        return;
      let r = e;
      try {
        "reason" in e ? r = e.reason : "detail" in e && "reason" in e.detail && (r = e.detail.reason);
      } catch {
      }
      if (Qn() || r && r.__sentry_own_request__)
        return !0;
      const s = In(r) ? Qs(r) : Ce(n, r, void 0, i, !0);
      s.level = "error", ii(t, r, s, "onunhandledrejection");
    }
  );
}
function Qs(e) {
  return {
    exception: {
      values: [
        {
          type: "UnhandledRejection",
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(e)}`
        }
      ]
    }
  };
}
function Zs(e, t, n, i) {
  const r = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
  let s = vn(e) ? e.message : e, o = "Error";
  const a = s.match(r);
  return a && (o = a[1], s = a[2]), ni({
    exception: {
      values: [
        {
          type: o,
          value: s
        }
      ]
    }
  }, t, n, i);
}
function ni(e, t, n, i) {
  const r = e.exception = e.exception || {}, s = r.values = r.values || [], o = s[0] = s[0] || {}, a = o.stacktrace = o.stacktrace || {}, c = a.frames = a.frames || [], u = isNaN(parseInt(i, 10)) ? void 0 : i, d = isNaN(parseInt(n, 10)) ? void 0 : n, _ = F(t) && t.length > 0 ? t : yi();
  return c.length === 0 && c.push({
    colno: u,
    filename: _,
    function: "?",
    in_app: !0,
    lineno: d
  }), e;
}
function to(e) {
  (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log(`Global Handler attached: ${e}`);
}
function ii(e, t, n, i) {
  Et(n, {
    handled: !1,
    type: i
  }), e.captureEvent(n, {
    originalException: t
  });
}
function ri() {
  const e = E(), t = e.getClient(), n = t && t.getOptions() || {
    stackParser: () => [],
    attachStacktrace: !1
  };
  return [e, n.stackParser, n.attachStacktrace];
}
const eo = [
  "EventTarget",
  "Window",
  "Node",
  "ApplicationCache",
  "AudioTrackList",
  "ChannelMergerNode",
  "CryptoOperation",
  "EventSource",
  "FileReader",
  "HTMLUnknownElement",
  "IDBDatabase",
  "IDBRequest",
  "IDBTransaction",
  "KeyOperation",
  "MediaController",
  "MessagePort",
  "ModalWindow",
  "Notification",
  "SVGElementInstance",
  "Screen",
  "TextTrack",
  "TextTrackCue",
  "TextTrackList",
  "WebSocket",
  "WebSocketWorker",
  "Worker",
  "XMLHttpRequest",
  "XMLHttpRequestEventTarget",
  "XMLHttpRequestUpload"
];
class bt {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "TryCatch";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = bt.id;
  }
  /** JSDoc */
  /**
   * @inheritDoc
   */
  constructor(t) {
    bt.prototype.__init.call(this), this._options = {
      XMLHttpRequest: !0,
      eventTarget: !0,
      requestAnimationFrame: !0,
      setInterval: !0,
      setTimeout: !0,
      ...t
    };
  }
  /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */
  setupOnce() {
    this._options.setTimeout && T(g, "setTimeout", ln), this._options.setInterval && T(g, "setInterval", ln), this._options.requestAnimationFrame && T(g, "requestAnimationFrame", no), this._options.XMLHttpRequest && "XMLHttpRequest" in g && T(XMLHttpRequest.prototype, "send", io);
    const t = this._options.eventTarget;
    t && (Array.isArray(t) ? t : eo).forEach(ro);
  }
}
bt.__initStatic();
function ln(e) {
  return function(...t) {
    const n = t[0];
    return t[0] = ut(n, {
      mechanism: {
        data: { function: H(e) },
        handled: !0,
        type: "instrument"
      }
    }), e.apply(this, t);
  };
}
function no(e) {
  return function(t) {
    return e.apply(this, [
      ut(t, {
        mechanism: {
          data: {
            function: "requestAnimationFrame",
            handler: H(e)
          },
          handled: !0,
          type: "instrument"
        }
      })
    ]);
  };
}
function io(e) {
  return function(...t) {
    const n = this;
    return ["onload", "onerror", "onprogress", "onreadystatechange"].forEach((r) => {
      r in n && typeof n[r] == "function" && T(n, r, function(s) {
        const o = {
          mechanism: {
            data: {
              function: r,
              handler: H(s)
            },
            handled: !0,
            type: "instrument"
          }
        }, a = Ue(s);
        return a && (o.mechanism.data.handler = H(a)), ut(s, o);
      });
    }), e.apply(this, t);
  };
}
function ro(e) {
  const t = g, n = t[e] && t[e].prototype;
  !n || !n.hasOwnProperty || !n.hasOwnProperty("addEventListener") || (T(n, "addEventListener", function(i) {
    return function(r, s, o) {
      try {
        typeof s.handleEvent == "function" && (s.handleEvent = ut(s.handleEvent, {
          mechanism: {
            data: {
              function: "handleEvent",
              handler: H(s),
              target: e
            },
            handled: !0,
            type: "instrument"
          }
        }));
      } catch {
      }
      return i.apply(this, [
        r,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ut(s, {
          mechanism: {
            data: {
              function: "addEventListener",
              handler: H(s),
              target: e
            },
            handled: !0,
            type: "instrument"
          }
        }),
        o
      ]);
    };
  }), T(
    n,
    "removeEventListener",
    function(i) {
      return function(r, s, o) {
        const a = s;
        try {
          const c = a && a.__sentry_wrapped__;
          c && i.call(this, r, c, o);
        } catch {
        }
        return i.call(this, r, a, o);
      };
    }
  ));
}
const so = "cause", oo = 5;
class nt {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "LinkedErrors";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = nt.id;
  }
  /**
   * @inheritDoc
   */
  /**
   * @inheritDoc
   */
  /**
   * @inheritDoc
   */
  constructor(t = {}) {
    nt.prototype.__init.call(this), this._key = t.key || so, this._limit = t.limit || oo;
  }
  /**
   * @inheritDoc
   */
  setupOnce() {
    const t = E().getClient();
    t && Ae((n, i) => {
      const r = E().getIntegration(nt);
      return r ? ao(t.getOptions().stackParser, r._key, r._limit, n, i) : n;
    });
  }
}
nt.__initStatic();
function ao(e, t, n, i, r) {
  if (!i.exception || !i.exception.values || !r || !O(r.originalException, Error))
    return i;
  const s = si(e, n, r.originalException, t);
  return i.exception.values = [...s, ...i.exception.values], i;
}
function si(e, t, n, i, r = []) {
  if (!O(n[i], Error) || r.length + 1 >= t)
    return r;
  const s = Zn(e, n[i]);
  return si(e, t, n[i], i, [s, ...r]);
}
class it {
  constructor() {
    it.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "HttpContext";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = it.id;
  }
  /**
   * @inheritDoc
   */
  setupOnce() {
    Ae((t) => {
      if (E().getIntegration(it)) {
        if (!g.navigator && !g.location && !g.document)
          return t;
        const n = t.request && t.request.url || g.location && g.location.href, { referrer: i } = g.document || {}, { userAgent: r } = g.navigator || {}, s = {
          ...t.request && t.request.headers,
          ...i && { Referer: i },
          ...r && { "User-Agent": r }
        }, o = { ...t.request, ...n && { url: n }, headers: s };
        return { ...t, request: o };
      }
      return t;
    });
  }
}
it.__initStatic();
class rt {
  constructor() {
    rt.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "Dedupe";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = rt.id;
  }
  /**
   * @inheritDoc
   */
  /**
   * @inheritDoc
   */
  setupOnce(t, n) {
    const i = (r) => {
      if (r.type)
        return r;
      const s = n().getIntegration(rt);
      if (s) {
        try {
          if (co(r, s._previousEvent))
            return (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn("Event dropped due to being a duplicate of previously captured event."), null;
        } catch {
          return s._previousEvent = r;
        }
        return s._previousEvent = r;
      }
      return r;
    };
    i.id = this.name, t(i);
  }
}
rt.__initStatic();
function co(e, t) {
  return t ? !!(uo(e, t) || _o(e, t)) : !1;
}
function uo(e, t) {
  const n = e.message, i = t.message;
  return !(!n && !i || n && !i || !n && i || n !== i || !ai(e, t) || !oi(e, t));
}
function _o(e, t) {
  const n = pn(t), i = pn(e);
  return !(!n || !i || n.type !== i.type || n.value !== i.value || !ai(e, t) || !oi(e, t));
}
function oi(e, t) {
  let n = hn(e), i = hn(t);
  if (!n && !i)
    return !0;
  if (n && !i || !n && i || (n = n, i = i, i.length !== n.length))
    return !1;
  for (let r = 0; r < i.length; r++) {
    const s = i[r], o = n[r];
    if (s.filename !== o.filename || s.lineno !== o.lineno || s.colno !== o.colno || s.function !== o.function)
      return !1;
  }
  return !0;
}
function ai(e, t) {
  let n = e.fingerprint, i = t.fingerprint;
  if (!n && !i)
    return !0;
  if (n && !i || !n && i)
    return !1;
  n = n, i = i;
  try {
    return n.join("") === i.join("");
  } catch {
    return !1;
  }
}
function pn(e) {
  return e.exception && e.exception.values && e.exception.values[0];
}
function hn(e) {
  const t = e.exception;
  if (t)
    try {
      return t.values[0].stacktrace.frames;
    } catch {
      return;
    }
}
const fo = [
  new et(),
  new Tt(),
  new bt(),
  new Rt(),
  new L(),
  new nt(),
  new rt(),
  new it()
];
function lo(e = {}) {
  e.defaultIntegrations === void 0 && (e.defaultIntegrations = fo), e.release === void 0 && (typeof __SENTRY_RELEASE__ == "string" && (e.release = __SENTRY_RELEASE__), g.SENTRY_RELEASE && g.SENTRY_RELEASE.id && (e.release = g.SENTRY_RELEASE.id)), e.autoSessionTracking === void 0 && (e.autoSessionTracking = !0), e.sendClientReports === void 0 && (e.sendClientReports = !0);
  const t = {
    ...e,
    stackParser: Ui(e.stackParser || Xs),
    integrations: Vr(e),
    transport: e.transport || (Yn() ? Os : As)
  };
  rs(ws, t), e.autoSessionTracking && po();
}
function mn(e) {
  e.startSession({ ignoreDuration: !0 }), e.captureSession();
}
function po() {
  if (typeof g.document > "u") {
    (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
    return;
  }
  const e = E();
  e.captureSession && (mn(e), w("history", ({ from: t, to: n }) => {
    t === void 0 || t === n || mn(E());
  }));
}
function h(e) {
  let t, n = e[0], i = 1;
  for (; i < e.length; ) {
    const r = e[i], s = e[i + 1];
    if (i += 2, (r === "optionalAccess" || r === "optionalCall") && n == null)
      return;
    r === "access" || r === "optionalAccess" ? (t = n, n = s(n)) : (r === "call" || r === "optionalCall") && (n = s((...o) => n.call(t, ...o)), t = void 0);
  }
  return n;
}
function K(e) {
  const t = h([e, "call", (i) => i(), "access", (i) => i.getClient, "call", (i) => i(), "optionalAccess", (i) => i.getOptions, "call", (i) => i()]);
  return (h([t, "optionalAccess", (i) => i.instrumenter]) || "sentry") !== "sentry";
}
class Ct {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "Express";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = Ct.id;
  }
  /**
   * Express App instance
   */
  /**
   * @inheritDoc
   */
  constructor(t = {}) {
    Ct.prototype.__init.call(this), this._router = t.router || t.app, this._methods = (Array.isArray(t.methods) ? t.methods : []).concat("use");
  }
  /**
   * @inheritDoc
   */
  setupOnce(t, n) {
    if (!this._router) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.error("ExpressIntegration is missing an Express instance");
      return;
    }
    if (K(n)) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("Express Integration is skipped because of instrumenter configuration.");
      return;
    }
    go(this._router, this._methods), Eo(this._router);
  }
}
Ct.__initStatic();
function gn(e, t) {
  const n = e.length;
  switch (n) {
    case 2:
      return function(i, r) {
        const s = r.__sentry_transaction;
        if (s) {
          const o = s.startChild({
            description: e.name,
            op: `middleware.express.${t}`
          });
          r.once("finish", () => {
            o.finish();
          });
        }
        return e.call(this, i, r);
      };
    case 3:
      return function(i, r, s) {
        const o = r.__sentry_transaction, a = h([o, "optionalAccess", (c) => c.startChild, "call", (c) => c({
          description: e.name,
          op: `middleware.express.${t}`
        })]);
        e.call(this, i, r, function(...c) {
          h([a, "optionalAccess", (u) => u.finish, "call", (u) => u()]), s.call(this, ...c);
        });
      };
    case 4:
      return function(i, r, s, o) {
        const a = s.__sentry_transaction, c = h([a, "optionalAccess", (u) => u.startChild, "call", (u) => u({
          description: e.name,
          op: `middleware.express.${t}`
        })]);
        e.call(this, i, r, s, function(...u) {
          h([c, "optionalAccess", (d) => d.finish, "call", (d) => d()]), o.call(this, ...u);
        });
      };
    default:
      throw new Error(`Express middleware takes 2-4 arguments. Got: ${n}`);
  }
}
function ho(e, t) {
  return e.map((n) => typeof n == "function" ? gn(n, t) : Array.isArray(n) ? n.map((i) => typeof i == "function" ? gn(i, t) : i) : n);
}
function mo(e, t) {
  const n = e[t];
  return e[t] = function(...i) {
    return n.call(this, ...ho(i, t));
  }, e;
}
function go(e, t = []) {
  t.forEach((n) => mo(e, n));
}
function Eo(e) {
  const t = "settings" in e;
  t && e._router === void 0 && e.lazyrouter && e.lazyrouter();
  const n = t ? e._router : e;
  if (!n) {
    (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.debug("Cannot instrument router for URL Parameterization (did not find a valid router)."), (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.debug("Routing instrumentation is currently only supported in Express 4.");
    return;
  }
  const i = Object.getPrototypeOf(n), r = i.process_params;
  i.process_params = function(o, a, c, u, d) {
    c._reconstructedRoute || (c._reconstructedRoute = "");
    const { layerRoutePath: _, isRegex: p, isArray: l, numExtraSegments: m } = yo(o);
    (_ || p || l) && (c._hasParameters = !0);
    const J = (_ || o.path || "").split("/").filter((Q) => Q.length > 0 && (p || l || !Q.includes("*"))).join("/");
    J && J.length > 0 && (c._reconstructedRoute += `/${J}${p ? "/" : ""}`);
    const ie = Yt(c.originalUrl || "") + m, fi = Yt(c._reconstructedRoute);
    if (ie === fi) {
      c._hasParameters || c._reconstructedRoute !== c.originalUrl && (c._reconstructedRoute = c.originalUrl);
      const Q = u.__sentry_transaction;
      if (Q && Q.metadata.source !== "custom") {
        const li = c._reconstructedRoute || "/";
        Q.setName(...nr(c, { path: !0, method: !0, customRoute: li }));
      }
    }
    return r.call(this, o, a, c, u, d);
  };
}
function yo(e) {
  const t = h([e, "access", (o) => o.route, "optionalAccess", (o) => o.path]), n = wn(t), i = Array.isArray(t);
  if (!t)
    return { isRegex: n, isArray: i, numExtraSegments: 0 };
  const r = i ? Math.max(So(t) - Yt(e.path || ""), 0) : 0;
  return { layerRoutePath: To(i, t), isRegex: n, isArray: i, numExtraSegments: r };
}
function So(e) {
  return e.reduce((t, n) => t + Yt(n.toString()), 0);
}
function To(e, t) {
  return e ? t.map((n) => n.toString()).join(",") : t && t.toString();
}
class Mt {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "Postgres";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = Mt.id;
  }
  constructor(t = {}) {
    Mt.prototype.__init.call(this), this._usePgNative = !!t.usePgNative;
  }
  /**
   * @inheritDoc
   */
  setupOnce(t, n) {
    if (K(n)) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("Postgres Integration is skipped because of instrumenter configuration.");
      return;
    }
    const i = V("pg");
    if (!i) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.error("Postgres Integration was unable to require `pg` package.");
      return;
    }
    if (this._usePgNative && !h([i, "access", (s) => s.native, "optionalAccess", (s) => s.Client])) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.error("Postgres Integration was unable to access 'pg-native' bindings.");
      return;
    }
    const { Client: r } = this._usePgNative ? i.native : i;
    T(r.prototype, "query", function(s) {
      return function(o, a, c) {
        const u = n().getScope(), d = h([u, "optionalAccess", (l) => l.getSpan, "call", (l) => l()]), _ = h([d, "optionalAccess", (l) => l.startChild, "call", (l) => l({
          description: typeof o == "string" ? o : o.text,
          op: "db"
        })]);
        if (typeof c == "function")
          return s.call(this, o, a, function(l, m) {
            h([_, "optionalAccess", (v) => v.finish, "call", (v) => v()]), c(l, m);
          });
        if (typeof a == "function")
          return s.call(this, o, function(l, m) {
            h([_, "optionalAccess", (v) => v.finish, "call", (v) => v()]), a(l, m);
          });
        const p = typeof a < "u" ? s.call(this, o, a) : s.call(this, o);
        return j(p) ? p.then((l) => (h([_, "optionalAccess", (m) => m.finish, "call", (m) => m()]), l)) : (h([_, "optionalAccess", (l) => l.finish, "call", (l) => l()]), p);
      };
    });
  }
}
Mt.__initStatic();
class Lt {
  constructor() {
    Lt.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "Mysql";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = Lt.id;
  }
  /**
   * @inheritDoc
   */
  setupOnce(t, n) {
    if (K(n)) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("Mysql Integration is skipped because of instrumenter configuration.");
      return;
    }
    const i = V("mysql/lib/Connection.js");
    if (!i) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.error("Mysql Integration was unable to require `mysql` package.");
      return;
    }
    T(i, "createQuery", function(r) {
      return function(s, o, a) {
        const c = n().getScope(), u = h([c, "optionalAccess", (_) => _.getSpan, "call", (_) => _()]), d = h([u, "optionalAccess", (_) => _.startChild, "call", (_) => _({
          description: typeof s == "string" ? s : s.sql,
          op: "db"
        })]);
        return typeof a == "function" ? r.call(this, s, o, function(_, p, l) {
          h([d, "optionalAccess", (m) => m.finish, "call", (m) => m()]), a(_, p, l);
        }) : typeof o == "function" ? r.call(this, s, function(_, p, l) {
          h([d, "optionalAccess", (m) => m.finish, "call", (m) => m()]), o(_, p, l);
        }) : r.call(this, s, o, a);
      };
    });
  }
}
Lt.__initStatic();
const Ro = [
  "aggregate",
  // aggregate(pipeline, options, callback)
  "bulkWrite",
  // bulkWrite(operations, options, callback)
  "countDocuments",
  // countDocuments(query, options, callback)
  "createIndex",
  // createIndex(fieldOrSpec, options, callback)
  "createIndexes",
  // createIndexes(indexSpecs, options, callback)
  "deleteMany",
  // deleteMany(filter, options, callback)
  "deleteOne",
  // deleteOne(filter, options, callback)
  "distinct",
  // distinct(key, query, options, callback)
  "drop",
  // drop(options, callback)
  "dropIndex",
  // dropIndex(indexName, options, callback)
  "dropIndexes",
  // dropIndexes(options, callback)
  "estimatedDocumentCount",
  // estimatedDocumentCount(options, callback)
  "find",
  // find(query, options, callback)
  "findOne",
  // findOne(query, options, callback)
  "findOneAndDelete",
  // findOneAndDelete(filter, options, callback)
  "findOneAndReplace",
  // findOneAndReplace(filter, replacement, options, callback)
  "findOneAndUpdate",
  // findOneAndUpdate(filter, update, options, callback)
  "indexes",
  // indexes(options, callback)
  "indexExists",
  // indexExists(indexes, options, callback)
  "indexInformation",
  // indexInformation(options, callback)
  "initializeOrderedBulkOp",
  // initializeOrderedBulkOp(options, callback)
  "insertMany",
  // insertMany(docs, options, callback)
  "insertOne",
  // insertOne(doc, options, callback)
  "isCapped",
  // isCapped(options, callback)
  "mapReduce",
  // mapReduce(map, reduce, options, callback)
  "options",
  // options(options, callback)
  "parallelCollectionScan",
  // parallelCollectionScan(options, callback)
  "rename",
  // rename(newName, options, callback)
  "replaceOne",
  // replaceOne(filter, doc, options, callback)
  "stats",
  // stats(options, callback)
  "updateMany",
  // updateMany(filter, update, options, callback)
  "updateOne"
  // updateOne(filter, update, options, callback)
], bo = {
  // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
  // see https://github.com/getsentry/sentry-javascript/pull/3102
  bulkWrite: ["operations"],
  countDocuments: ["query"],
  createIndex: ["fieldOrSpec"],
  createIndexes: ["indexSpecs"],
  deleteMany: ["filter"],
  deleteOne: ["filter"],
  distinct: ["key", "query"],
  dropIndex: ["indexName"],
  find: ["query"],
  findOne: ["query"],
  findOneAndDelete: ["filter"],
  findOneAndReplace: ["filter", "replacement"],
  findOneAndUpdate: ["filter", "update"],
  indexExists: ["indexes"],
  insertMany: ["docs"],
  insertOne: ["doc"],
  mapReduce: ["map", "reduce"],
  rename: ["newName"],
  replaceOne: ["filter", "doc"],
  updateMany: ["filter", "update"],
  updateOne: ["filter", "update"]
};
function No(e) {
  return e && typeof e == "object" && e.once && typeof e.once == "function";
}
class Ft {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "Mongo";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = Ft.id;
  }
  /**
   * @inheritDoc
   */
  constructor(t = {}) {
    Ft.prototype.__init.call(this), this._operations = Array.isArray(t.operations) ? t.operations : Ro, this._describeOperations = "describeOperations" in t ? t.describeOperations : !0, this._useMongoose = !!t.useMongoose;
  }
  /**
   * @inheritDoc
   */
  setupOnce(t, n) {
    if (K(n)) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("Mongo Integration is skipped because of instrumenter configuration.");
      return;
    }
    const i = this._useMongoose ? "mongoose" : "mongodb", r = V(i);
    if (!r) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.error(`Mongo Integration was unable to require \`${i}\` package.`);
      return;
    }
    this._instrumentOperations(r.Collection, this._operations, n);
  }
  /**
   * Patches original collection methods
   */
  _instrumentOperations(t, n, i) {
    n.forEach((r) => this._patchOperation(t, r, i));
  }
  /**
   * Patches original collection to utilize our tracing functionality
   */
  _patchOperation(t, n, i) {
    if (!(n in t.prototype))
      return;
    const r = this._getSpanContextFromOperationArguments.bind(this);
    T(t.prototype, n, function(s) {
      return function(...o) {
        const a = o[o.length - 1], c = i().getScope(), u = h([c, "optionalAccess", (_) => _.getSpan, "call", (_) => _()]);
        if (typeof a != "function" || n === "mapReduce" && o.length === 2) {
          const _ = h([u, "optionalAccess", (l) => l.startChild, "call", (l) => l(r(this, n, o))]), p = s.call(this, ...o);
          if (j(p))
            return p.then((l) => (h([_, "optionalAccess", (m) => m.finish, "call", (m) => m()]), l));
          if (No(p)) {
            const l = p;
            try {
              l.once("close", () => {
                h([_, "optionalAccess", (m) => m.finish, "call", (m) => m()]);
              });
            } catch {
              h([_, "optionalAccess", (v) => v.finish, "call", (v) => v()]);
            }
            return l;
          } else
            return h([_, "optionalAccess", (l) => l.finish, "call", (l) => l()]), p;
        }
        const d = h([u, "optionalAccess", (_) => _.startChild, "call", (_) => _(r(this, n, o.slice(0, -1)))]);
        return s.call(this, ...o.slice(0, -1), function(_, p) {
          h([d, "optionalAccess", (l) => l.finish, "call", (l) => l()]), a(_, p);
        });
      };
    });
  }
  /**
   * Form a SpanContext based on the user input to a given operation.
   */
  _getSpanContextFromOperationArguments(t, n, i) {
    const r = {
      collectionName: t.collectionName,
      dbName: t.dbName,
      namespace: t.namespace
    }, s = {
      op: "db",
      description: n,
      data: r
    }, o = bo[n], a = Array.isArray(this._describeOperations) ? this._describeOperations.includes(n) : this._describeOperations;
    if (!o || !a)
      return s;
    try {
      if (n === "mapReduce") {
        const [c, u] = i;
        r[o[0]] = typeof c == "string" ? c : c.name || "<anonymous>", r[o[1]] = typeof u == "string" ? u : u.name || "<anonymous>";
      } else
        for (let c = 0; c < o.length; c++)
          r[o[c]] = JSON.stringify(i[c]);
    } catch {
    }
    return s;
  }
}
Ft.__initStatic();
function Do(e) {
  return e && !!e.$use;
}
class Ht {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "Prisma";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = Ht.id;
  }
  /**
   * Prisma ORM Client Instance
   */
  /**
   * @inheritDoc
   */
  constructor(t = {}) {
    Ht.prototype.__init.call(this), Do(t.client) ? this._client = t.client : (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn(
      `Unsupported Prisma client provided to PrismaIntegration. Provided client: ${JSON.stringify(t.client)}`
    );
  }
  /**
   * @inheritDoc
   */
  setupOnce(t, n) {
    if (!this._client) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.error("PrismaIntegration is missing a Prisma Client Instance");
      return;
    }
    if (K(n)) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("Prisma Integration is skipped because of instrumenter configuration.");
      return;
    }
    this._client.$use((i, r) => {
      const s = n().getScope(), o = h([s, "optionalAccess", (_) => _.getSpan, "call", (_) => _()]), a = i.action, c = i.model, u = h([o, "optionalAccess", (_) => _.startChild, "call", (_) => _({
        description: c ? `${c} ${a}` : a,
        op: "db.sql.prisma"
      })]), d = r(i);
      return j(d) ? d.then((_) => (h([u, "optionalAccess", (p) => p.finish, "call", (p) => p()]), _)) : (h([u, "optionalAccess", (_) => _.finish, "call", (_) => _()]), d);
    });
  }
}
Ht.__initStatic();
class jt {
  constructor() {
    jt.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "GraphQL";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = jt.id;
  }
  /**
   * @inheritDoc
   */
  setupOnce(t, n) {
    if (K(n)) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("GraphQL Integration is skipped because of instrumenter configuration.");
      return;
    }
    const i = V("graphql/execution/execute.js");
    if (!i) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.error("GraphQL Integration was unable to require graphql/execution package.");
      return;
    }
    T(i, "execute", function(r) {
      return function(...s) {
        const o = n().getScope(), a = h([o, "optionalAccess", (d) => d.getSpan, "call", (d) => d()]), c = h([a, "optionalAccess", (d) => d.startChild, "call", (d) => d({
          description: "execute",
          op: "graphql.execute"
        })]);
        h([o, "optionalAccess", (d) => d.setSpan, "call", (d) => d(c)]);
        const u = r.call(this, ...s);
        return j(u) ? u.then((d) => (h([c, "optionalAccess", (_) => _.finish, "call", (_) => _()]), h([o, "optionalAccess", (_) => _.setSpan, "call", (_) => _(a)]), d)) : (h([c, "optionalAccess", (d) => d.finish, "call", (d) => d()]), h([o, "optionalAccess", (d) => d.setSpan, "call", (d) => d(a)]), u);
      };
    });
  }
}
jt.__initStatic();
class qt {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "Apollo";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = qt.id;
  }
  /**
   * @inheritDoc
   */
  constructor(t = {
    useNestjs: !1
  }) {
    qt.prototype.__init.call(this), this._useNest = !!t.useNestjs;
  }
  /**
   * @inheritDoc
   */
  setupOnce(t, n) {
    if (K(n)) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("Apollo Integration is skipped because of instrumenter configuration.");
      return;
    }
    if (this._useNest) {
      const i = V("@nestjs/graphql");
      if (!i) {
        (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.error("Apollo-NestJS Integration was unable to require @nestjs/graphql package.");
        return;
      }
      T(
        i.GraphQLFactory.prototype,
        "mergeWithSchema",
        function(r) {
          return function(...s) {
            return T(this.resolversExplorerService, "explore", function(o) {
              return function() {
                const a = yt(o.call(this));
                return En(a, n);
              };
            }), r.call(this, ...s);
          };
        }
      );
    } else {
      const i = V("apollo-server-core");
      if (!i) {
        (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.error("Apollo Integration was unable to require apollo-server-core package.");
        return;
      }
      T(i.ApolloServerBase.prototype, "constructSchema", function(r) {
        return function() {
          if (!this.config.resolvers)
            return (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && (this.config.schema ? (f.warn(
              "Apollo integration is not able to trace `ApolloServer` instances constructed via `schema` property.If you are using NestJS with Apollo, please use `Sentry.Integrations.Apollo({ useNestjs: true })` instead."
            ), f.warn()) : this.config.modules && f.warn(
              "Apollo integration is not able to trace `ApolloServer` instances constructed via `modules` property."
            ), f.error("Skipping tracing as no resolvers found on the `ApolloServer` instance.")), r.call(this);
          const s = yt(this.config.resolvers);
          return this.config.resolvers = En(s, n), r.call(this);
        };
      });
    }
  }
}
qt.__initStatic();
function En(e, t) {
  return e.map((n) => (Object.keys(n).forEach((i) => {
    Object.keys(n[i]).forEach((r) => {
      typeof n[i][r] == "function" && vo(n, i, r, t);
    });
  }), n));
}
function vo(e, t, n, i) {
  T(e[t], n, function(r) {
    return function(...s) {
      const o = i().getScope(), a = h([o, "optionalAccess", (d) => d.getSpan, "call", (d) => d()]), c = h([a, "optionalAccess", (d) => d.startChild, "call", (d) => d({
        description: `${t}.${n}`,
        op: "graphql.resolve"
      })]), u = r.call(this, ...s);
      return j(u) ? u.then((d) => (h([c, "optionalAccess", (_) => _.finish, "call", (_) => _()]), d)) : (h([c, "optionalAccess", (d) => d.finish, "call", (d) => d()]), u);
    };
  });
}
const y = I;
function Io() {
  y && y.document ? y.document.addEventListener("visibilitychange", () => {
    const e = Qt();
    if (y.document.hidden && e) {
      const t = "cancelled";
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log(
        `[Tracing] Transaction: ${t} -> since tab moved to the background, op: ${e.op}`
      ), e.status || e.setStatus(t), e.setTag("visibilitychange", "document.hidden"), e.finish();
    }
  }) : (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn("[Tracing] Could not set up background tab detection due to lack of global document");
}
const Le = (e, t, n) => {
  let i, r;
  return (s) => {
    t.value >= 0 && (s || n) && (r = t.value - (i || 0), (r || i === void 0) && (i = t.value, t.delta = r, e(t)));
  };
}, wo = () => `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`, ko = () => {
  const e = y.performance.timing, t = y.performance.navigation.type, n = {
    entryType: "navigation",
    startTime: 0,
    type: t == 2 ? "back_forward" : t === 1 ? "reload" : "navigate"
  };
  for (const i in e)
    i !== "navigationStart" && i !== "toJSON" && (n[i] = Math.max(e[i] - e.navigationStart, 0));
  return n;
}, ci = () => y.__WEB_VITALS_POLYFILL__ ? y.performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || ko()) : y.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0], ui = () => {
  const e = ci();
  return e && e.activationStart || 0;
}, Fe = (e, t) => {
  const n = ci();
  let i = "navigate";
  return n && (y.document.prerendering || ui() > 0 ? i = "prerender" : i = n.type.replace(/_/g, "-")), {
    name: e,
    value: typeof t > "u" ? -1 : t,
    rating: "good",
    // Will be updated if the value changes.
    delta: 0,
    entries: [],
    id: wo(),
    navigationType: i
  };
}, Nt = (e, t, n) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      const i = new PerformanceObserver((r) => {
        t(r.getEntries());
      });
      return i.observe(
        Object.assign(
          {
            type: e,
            buffered: !0
          },
          n || {}
        )
      ), i;
    }
  } catch {
  }
}, ee = (e, t) => {
  const n = (i) => {
    (i.type === "pagehide" || y.document.visibilityState === "hidden") && (e(i), t && (removeEventListener("visibilitychange", n, !0), removeEventListener("pagehide", n, !0)));
  };
  addEventListener("visibilitychange", n, !0), addEventListener("pagehide", n, !0);
}, Uo = (e) => {
  const t = Fe("CLS", 0);
  let n, i = 0, r = [];
  const s = (a) => {
    a.forEach((c) => {
      if (!c.hadRecentInput) {
        const u = r[0], d = r[r.length - 1];
        i && r.length !== 0 && c.startTime - d.startTime < 1e3 && c.startTime - u.startTime < 5e3 ? (i += c.value, r.push(c)) : (i = c.value, r = [c]), i > t.value && (t.value = i, t.entries = r, n && n());
      }
    });
  }, o = Nt("layout-shift", s);
  if (o) {
    n = Le(e, t);
    const a = () => {
      s(o.takeRecords()), n(!0);
    };
    return ee(a), a;
  }
};
let At = -1;
const Oo = () => y.document.visibilityState === "hidden" && !y.document.prerendering ? 0 : 1 / 0, Bo = () => {
  ee(({ timeStamp: e }) => {
    At = e;
  }, !0);
}, He = () => (At < 0 && (At = Oo(), Bo()), {
  get firstHiddenTime() {
    return At;
  }
}), Ao = (e) => {
  const t = He(), n = Fe("FID");
  let i;
  const r = (a) => {
    a.startTime < t.firstHiddenTime && (n.value = a.processingStart - a.startTime, n.entries.push(a), i(!0));
  }, s = (a) => {
    a.forEach(r);
  }, o = Nt("first-input", s);
  i = Le(e, n), o && ee(() => {
    s(o.takeRecords()), o.disconnect();
  }, !0);
}, yn = {}, Go = (e) => {
  const t = He(), n = Fe("LCP");
  let i;
  const r = (o) => {
    const a = o[o.length - 1];
    if (a) {
      const c = Math.max(a.startTime - ui(), 0);
      c < t.firstHiddenTime && (n.value = c, n.entries = [a], i());
    }
  }, s = Nt("largest-contentful-paint", r);
  if (s) {
    i = Le(e, n);
    const o = () => {
      yn[n.id] || (r(s.takeRecords()), s.disconnect(), yn[n.id] = !0, i(!0));
    };
    return ["keydown", "click"].forEach((a) => {
      addEventListener(a, o, { once: !0, capture: !0 });
    }), ee(o, !0), o;
  }
};
function _e(e) {
  return typeof e == "number" && isFinite(e);
}
function _t(e, { startTimestamp: t, ...n }) {
  return t && e.startTimestamp > t && (e.startTimestamp = t), e.startChild({
    startTimestamp: t,
    ...n
  });
}
function b(e) {
  return e / 1e3;
}
function _i() {
  return y && y.addEventListener && y.performance;
}
let Sn = 0, R = {}, U, mt;
function xo() {
  const e = _i();
  if (e && at) {
    e.mark && y.performance.mark("sentry-tracing-init"), Mo();
    const t = Po(), n = Co();
    return () => {
      t && t(), n && n();
    };
  }
  return () => {
  };
}
function Yo() {
  Nt("longtask", (t) => {
    for (const n of t) {
      const i = Qt();
      if (!i)
        return;
      const r = b(at + n.startTime), s = b(n.duration);
      i.startChild({
        description: "Main UI thread blocked",
        op: "ui.long-task",
        startTimestamp: r,
        endTimestamp: r + s
      });
    }
  });
}
function $o() {
  Nt("event", (t) => {
    for (const n of t) {
      const i = Qt();
      if (!i)
        return;
      if (n.name === "click") {
        const r = b(at + n.startTime), s = b(n.duration);
        i.startChild({
          description: ot(n.target),
          op: `ui.interaction.${n.name}`,
          startTimestamp: r,
          endTimestamp: r + s
        });
      }
    }
  }, { durationThreshold: 0 });
}
function Po() {
  return Uo((e) => {
    const t = e.entries.pop();
    t && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("[Measurements] Adding CLS"), R.cls = { value: e.value, unit: "" }, mt = t);
  });
}
function Co() {
  return Go((e) => {
    const t = e.entries.pop();
    t && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("[Measurements] Adding LCP"), R.lcp = { value: e.value, unit: "millisecond" }, U = t);
  });
}
function Mo() {
  Ao((e) => {
    const t = e.entries.pop();
    if (!t)
      return;
    const n = b(at), i = b(t.startTime);
    (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("[Measurements] Adding FID"), R.fid = { value: e.value, unit: "millisecond" }, R["mark.fid"] = { value: n + i, unit: "second" };
  });
}
function Lo(e) {
  const t = _i();
  if (!t || !y.performance.getEntries || !at)
    return;
  (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("[Tracing] Adding & adjusting spans using Performance API");
  const n = b(at), i = t.getEntries();
  let r, s;
  if (i.slice(Sn).forEach((o) => {
    const a = b(o.startTime), c = b(o.duration);
    if (!(e.op === "navigation" && n + a < e.startTimestamp))
      switch (o.entryType) {
        case "navigation": {
          Ho(e, o, n), r = n + b(o.responseStart), s = n + b(o.requestStart);
          break;
        }
        case "mark":
        case "paint":
        case "measure": {
          Fo(e, o, a, c, n);
          const u = He(), d = o.startTime < u.firstHiddenTime;
          o.name === "first-paint" && d && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("[Measurements] Adding FP"), R.fp = { value: o.startTime, unit: "millisecond" }), o.name === "first-contentful-paint" && d && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("[Measurements] Adding FCP"), R.fcp = { value: o.startTime, unit: "millisecond" });
          break;
        }
        case "resource": {
          const u = o.name.replace(y.location.origin, "");
          qo(e, o, u, a, c, n);
          break;
        }
      }
  }), Sn = Math.max(i.length - 1, 0), Wo(e), e.op === "pageload") {
    typeof r == "number" && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("[Measurements] Adding TTFB"), R.ttfb = {
      value: (r - e.startTimestamp) * 1e3,
      unit: "millisecond"
    }, typeof s == "number" && s <= r && (R["ttfb.requestTime"] = {
      value: (r - s) * 1e3,
      unit: "millisecond"
    })), ["fcp", "fp", "lcp"].forEach((a) => {
      if (!R[a] || n >= e.startTimestamp)
        return;
      const c = R[a].value, u = n + b(c), d = Math.abs((u - e.startTimestamp) * 1e3), _ = d - c;
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log(`[Measurements] Normalized ${a} from ${c} to ${d} (${_})`), R[a].value = d;
    });
    const o = R["mark.fid"];
    o && R.fid && (_t(e, {
      description: "first input delay",
      endTimestamp: o.value + b(R.fid.value),
      op: "ui.action",
      startTimestamp: o.value
    }), delete R["mark.fid"]), "fcp" in R || delete R.cls, Object.keys(R).forEach((a) => {
      e.setMeasurement(
        a,
        R[a].value,
        R[a].unit
      );
    }), zo(e);
  }
  U = void 0, mt = void 0, R = {};
}
function Fo(e, t, n, i, r) {
  const s = r + n, o = s + i;
  return _t(e, {
    description: t.name,
    endTimestamp: o,
    op: t.entryType,
    startTimestamp: s
  }), s;
}
function Ho(e, t, n) {
  ["unloadEvent", "redirect", "domContentLoadedEvent", "loadEvent", "connect"].forEach((i) => {
    Ut(e, t, i, n);
  }), Ut(e, t, "secureConnection", n, "TLS/SSL", "connectEnd"), Ut(e, t, "fetch", n, "cache", "domainLookupStart"), Ut(e, t, "domainLookup", n, "DNS"), jo(e, t, n);
}
function Ut(e, t, n, i, r, s) {
  const o = s ? t[s] : t[`${n}End`], a = t[`${n}Start`];
  !a || !o || _t(e, {
    op: "browser",
    description: r || n,
    startTimestamp: i + b(a),
    endTimestamp: i + b(o)
  });
}
function jo(e, t, n) {
  _t(e, {
    op: "browser",
    description: "request",
    startTimestamp: n + b(t.requestStart),
    endTimestamp: n + b(t.responseEnd)
  }), _t(e, {
    op: "browser",
    description: "response",
    startTimestamp: n + b(t.responseStart),
    endTimestamp: n + b(t.responseEnd)
  });
}
function qo(e, t, n, i, r, s) {
  if (t.initiatorType === "xmlhttprequest" || t.initiatorType === "fetch")
    return;
  const o = {};
  "transferSize" in t && (o["Transfer Size"] = t.transferSize), "encodedBodySize" in t && (o["Encoded Body Size"] = t.encodedBodySize), "decodedBodySize" in t && (o["Decoded Body Size"] = t.decodedBodySize), "renderBlockingStatus" in t && (o["resource.render_blocking_status"] = t.renderBlockingStatus);
  const a = s + i, c = a + r;
  _t(e, {
    description: n,
    endTimestamp: c,
    op: t.initiatorType ? `resource.${t.initiatorType}` : "resource.other",
    startTimestamp: a,
    data: o
  });
}
function Wo(e) {
  const t = y.navigator;
  if (!t)
    return;
  const n = t.connection;
  n && (n.effectiveType && e.setTag("effectiveConnectionType", n.effectiveType), n.type && e.setTag("connectionType", n.type), _e(n.rtt) && (R["connection.rtt"] = { value: n.rtt, unit: "millisecond" })), _e(t.deviceMemory) && e.setTag("deviceMemory", `${t.deviceMemory} GB`), _e(t.hardwareConcurrency) && e.setTag("hardwareConcurrency", String(t.hardwareConcurrency));
}
function zo(e) {
  U && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("[Measurements] Adding LCP Data"), U.element && e.setTag("lcp.element", ot(U.element)), U.id && e.setTag("lcp.id", U.id), U.url && e.setTag("lcp.url", U.url.trim().slice(0, 200)), e.setTag("lcp.size", U.size)), mt && mt.sources && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log("[Measurements] Adding CLS Data"), mt.sources.forEach(
    (t, n) => e.setTag(`cls.source.${n + 1}`, ot(t.node))
  ));
}
const Re = ["localhost", /^\//], be = {
  traceFetch: !0,
  traceXHR: !0,
  // TODO (v8): Remove this property
  tracingOrigins: Re,
  tracePropagationTargets: Re
};
function Vo(e) {
  const { traceFetch: t, traceXHR: n, tracePropagationTargets: i, tracingOrigins: r, shouldCreateSpanForRequest: s } = {
    traceFetch: be.traceFetch,
    traceXHR: be.traceXHR,
    ...e
  }, o = typeof s == "function" ? s : (u) => !0, a = (u) => Xo(u, i || r), c = {};
  t && w("fetch", (u) => {
    Ko(u, o, a, c);
  }), n && w("xhr", (u) => {
    Qo(u, o, a, c);
  });
}
function Xo(e, t) {
  return zt(e, t || Re);
}
function Ko(e, t, n, i) {
  if (!Jt() || !(e.fetchData && t(e.fetchData.url)))
    return;
  if (e.endTimestamp) {
    const a = e.fetchData.__span;
    if (!a)
      return;
    const c = i[a];
    c && (e.response ? c.setHttpStatus(e.response.status) : e.error && c.setStatus("internal_error"), c.finish(), delete i[a]);
    return;
  }
  const r = E().getScope(), s = r && r.getSpan(), o = s && s.transaction;
  if (s && o) {
    const a = s.startChild({
      data: {
        ...e.fetchData,
        type: "fetch"
      },
      description: `${e.fetchData.method} ${e.fetchData.url}`,
      op: "http.client"
    });
    e.fetchData.__span = a.spanId, i[a.spanId] = a;
    const c = e.args[0];
    e.args[1] = e.args[1] || {};
    const u = e.args[1];
    n(e.fetchData.url) && (u.headers = Jo(
      c,
      o.getDynamicSamplingContext(),
      a,
      u
    ));
  }
}
function Jo(e, t, n, i) {
  const r = Fn(t), s = n.toTraceparent(), o = typeof Request < "u" && O(e, Request) ? e.headers : i.headers;
  if (o)
    if (typeof Headers < "u" && O(o, Headers)) {
      const a = new Headers(o);
      return a.append("sentry-trace", s), r && a.append(Ee, r), a;
    } else if (Array.isArray(o)) {
      const a = [...o, ["sentry-trace", s]];
      return r && a.push([Ee, r]), a;
    } else {
      const a = "baggage" in o ? o.baggage : void 0, c = [];
      return Array.isArray(a) ? c.push(...a) : a && c.push(a), r && c.push(r), {
        ...o,
        "sentry-trace": s,
        baggage: c.length > 0 ? c.join(",") : void 0
      };
    }
  else
    return { "sentry-trace": s, baggage: r };
}
function Qo(e, t, n, i) {
  if (!Jt() || e.xhr && e.xhr.__sentry_own_request__ || !(e.xhr && e.xhr.__sentry_xhr__ && t(e.xhr.__sentry_xhr__.url)))
    return;
  const r = e.xhr.__sentry_xhr__;
  if (e.endTimestamp) {
    const c = e.xhr.__sentry_xhr_span_id__;
    if (!c)
      return;
    const u = i[c];
    u && (u.setHttpStatus(r.status_code), u.finish(), delete i[c]);
    return;
  }
  const s = E().getScope(), o = s && s.getSpan(), a = o && o.transaction;
  if (o && a) {
    const c = o.startChild({
      data: {
        ...r.data,
        type: "xhr",
        method: r.method,
        url: r.url
      },
      description: `${r.method} ${r.url}`,
      op: "http.client"
    });
    if (e.xhr.__sentry_xhr_span_id__ = c.spanId, i[e.xhr.__sentry_xhr_span_id__] = c, e.xhr.setRequestHeader && n(e.xhr.__sentry_xhr__.url))
      try {
        e.xhr.setRequestHeader("sentry-trace", c.toTraceparent());
        const u = a.getDynamicSamplingContext(), d = Fn(u);
        d && e.xhr.setRequestHeader(Ee, d);
      } catch {
      }
  }
}
function Zo(e, t = !0, n = !0) {
  if (!y || !y.location) {
    (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn("Could not initialize routing instrumentation due to invalid location");
    return;
  }
  let i = y.location.href, r;
  t && (r = e({
    name: y.location.pathname,
    op: "pageload",
    metadata: { source: "url" }
  })), n && w("history", ({ to: s, from: o }) => {
    if (o === void 0 && i && i.indexOf(s) !== -1) {
      i = void 0;
      return;
    }
    o !== s && (i = void 0, r && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log(`[Tracing] Finishing current transaction with op: ${r.op}`), r.finish()), r = e({
      name: y.location.pathname,
      op: "navigation",
      metadata: { source: "url" }
    }));
  });
}
const ta = "BrowserTracing", ea = {
  ...Bt,
  markBackgroundTransactions: !0,
  routingInstrumentation: Zo,
  startTransactionOnLocationChange: !0,
  startTransactionOnPageLoad: !0,
  enableLongTask: !0,
  _experiments: {},
  ...be
};
class je {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.
  /** Browser Tracing integration options */
  /**
   * @inheritDoc
   */
  __init() {
    this.name = ta;
  }
  constructor(t) {
    je.prototype.__init.call(this), Wn(), this.options = {
      ...ea,
      ...t
    }, this.options._experiments.enableLongTask !== void 0 && (this.options.enableLongTask = this.options._experiments.enableLongTask), t && !t.tracePropagationTargets && t.tracingOrigins && (this.options.tracePropagationTargets = t.tracingOrigins), this._collectWebVitals = xo(), this.options.enableLongTask && Yo(), this.options._experiments.enableInteractions && $o();
  }
  /**
   * @inheritDoc
   */
  setupOnce(t, n) {
    this._getCurrentHub = n;
    const {
      routingInstrumentation: i,
      startTransactionOnLocationChange: r,
      startTransactionOnPageLoad: s,
      markBackgroundTransactions: o,
      traceFetch: a,
      traceXHR: c,
      tracePropagationTargets: u,
      shouldCreateSpanForRequest: d,
      _experiments: _
    } = this.options;
    i(
      (p) => {
        const l = this._createRouteTransaction(p);
        return this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(l, p, n), l;
      },
      s,
      r
    ), o && Io(), _.enableInteractions && this._registerInteractionListener(), Vo({
      traceFetch: a,
      traceXHR: c,
      tracePropagationTargets: u,
      shouldCreateSpanForRequest: d
    });
  }
  /** Create routing idle transaction. */
  _createRouteTransaction(t) {
    if (!this._getCurrentHub) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn(`[Tracing] Did not create ${t.op} transaction because _getCurrentHub is invalid.`);
      return;
    }
    const { beforeNavigate: n, idleTimeout: i, finalTimeout: r, heartbeatInterval: s } = this.options, o = t.op === "pageload", a = o ? Tn("sentry-trace") : null, c = o ? Tn("baggage") : null, u = a ? cr(a) : void 0, d = c ? br(c) : void 0, _ = {
      ...t,
      ...u,
      metadata: {
        ...t.metadata,
        dynamicSamplingContext: u && !d ? {} : d
      },
      trimEnd: !0
    }, p = typeof n == "function" ? n(_) : _, l = p === void 0 ? { ..._, sampled: !1 } : p;
    l.metadata = l.name !== _.name ? { ...l.metadata, source: "custom" } : l.metadata, this._latestRouteName = l.name, this._latestRouteSource = l.metadata && l.metadata.source, l.sampled === !1 && (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log(`[Tracing] Will not send ${l.op} transaction because of beforeNavigate.`), (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.log(`[Tracing] Starting ${l.op} transaction on scope`);
    const m = this._getCurrentHub(), { location: v } = y, J = cn(
      m,
      l,
      i,
      r,
      !0,
      { location: v },
      // for use in the tracesSampler
      s
    );
    return J.registerBeforeFinishCallback((ie) => {
      this._collectWebVitals(), Lo(ie);
    }), J;
  }
  /** Start listener for interaction transactions */
  _registerInteractionListener() {
    let t;
    const n = () => {
      const { idleTimeout: i, finalTimeout: r, heartbeatInterval: s } = this.options, o = "ui.action.click";
      if (t && (t.finish(), t = void 0), !this._getCurrentHub) {
        (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn(`[Tracing] Did not create ${o} transaction because _getCurrentHub is invalid.`);
        return;
      }
      if (!this._latestRouteName) {
        (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn(`[Tracing] Did not create ${o} transaction because _latestRouteName is missing.`);
        return;
      }
      const a = this._getCurrentHub(), { location: c } = y, u = {
        name: this._latestRouteName,
        op: o,
        trimEnd: !0,
        metadata: {
          source: this._latestRouteSource || "url"
        }
      };
      t = cn(
        a,
        u,
        i,
        r,
        !0,
        { location: c },
        // for use in the tracesSampler
        s
      );
    };
    ["click"].forEach((i) => {
      addEventListener(i, n, { once: !1, capture: !0 });
    });
  }
}
function Tn(e) {
  const t = Si(`meta[name=${e}]`);
  return t ? t.getAttribute("content") : null;
}
function na() {
  const e = ft();
  if (!e.__SENTRY__)
    return;
  const t = {
    mongodb() {
      const i = $(module, "./node/integrations/mongo");
      return new i.Mongo();
    },
    mongoose() {
      const i = $(module, "./node/integrations/mongo");
      return new i.Mongo({ mongoose: !0 });
    },
    mysql() {
      const i = $(module, "./node/integrations/mysql");
      return new i.Mysql();
    },
    pg() {
      const i = $(module, "./node/integrations/postgres");
      return new i.Postgres();
    }
  }, n = Object.keys(t).filter((i) => !!V(i)).map((i) => {
    try {
      return t[i]();
    } catch {
      return;
    }
  }).filter((i) => i);
  n.length > 0 && (e.__SENTRY__.integrations = [...e.__SENTRY__.integrations || [], ...n]);
}
function ia() {
  Wn(), Oe() && na();
}
const di = ["activate", "mount", "update"], ra = /(?:^|[-_])(\w)/g, sa = (e) => e.replace(ra, (t) => t.toUpperCase()).replace(/[-_]/g, ""), oa = "<Root>", de = "<Anonymous>", aa = (e, t) => e.repeat ? e.repeat(t) : e, gt = (e, t) => {
  if (!e)
    return de;
  if (e.$root === e)
    return oa;
  if (!e.$options)
    return de;
  const n = e.$options;
  let i = n.name || n._componentTag;
  const r = n.__file;
  if (!i && r) {
    const s = r.match(/([^/\\]+)\.vue$/);
    s && (i = s[1]);
  }
  return (i ? `<${sa(i)}>` : de) + (r && t !== !1 ? ` at ${r}` : "");
}, ca = (e) => {
  if (e && (e._isVue || e.__isVue) && e.$parent) {
    const t = [];
    let n = 0;
    for (; e; ) {
      if (t.length > 0) {
        const r = t[t.length - 1];
        if (r.constructor === e.constructor) {
          n++, e = e.$parent;
          continue;
        } else
          n > 0 && (t[t.length - 1] = [r, n], n = 0);
      }
      t.push(e), e = e.$parent;
    }
    return `

found in

${t.map(
      (r, s) => `${(s === 0 ? "---> " : aa(" ", 5 + s * 2)) + (Array.isArray(r) ? `${gt(r[0])}... (${r[1]} recursive calls)` : gt(r))}`
    ).join(`
`)}`;
  }
  return `

(found in ${gt(e)})`;
}, ua = (e, t) => {
  const { errorHandler: n, warnHandler: i, silent: r } = e.config;
  e.config.errorHandler = (s, o, a) => {
    const c = gt(o, !1), u = o ? ca(o) : "", d = {
      componentName: c,
      lifecycleHook: a,
      trace: u
    };
    if (t.attachProps && o && (o.$options && o.$options.propsData ? d.propsData = o.$options.propsData : o.$props && (d.propsData = o.$props)), setTimeout(() => {
      E().withScope((_) => {
        _.setContext("vue", d), E().captureException(s);
      });
    }), typeof n == "function" && n.call(e, s, o, a), t.logErrors) {
      const _ = typeof console < "u", p = `Error in ${a}: "${s && s.toString()}"`;
      i ? i.call(null, p, o, u) : _ && !r && console.error(`[Vue warn]: ${p}${u}`);
    }
  };
}, Rn = "ui.vue", _a = {
  activate: ["activated", "deactivated"],
  create: ["beforeCreate", "created"],
  destroy: ["beforeDestroy", "destroyed"],
  mount: ["beforeMount", "mounted"],
  update: ["beforeUpdate", "updated"]
};
function Ne() {
  const e = E().getScope();
  return e && e.getTransaction();
}
function da(e, t, n) {
  e.$_sentryRootSpanTimer && clearTimeout(e.$_sentryRootSpanTimer), e.$_sentryRootSpanTimer = setTimeout(() => {
    e.$root && e.$root.$_sentryRootSpan && (e.$root.$_sentryRootSpan.finish(t), e.$root.$_sentryRootSpan = void 0);
  }, n);
}
const fa = (e) => {
  const t = (e.hooks || []).concat(di).filter((i, r, s) => s.indexOf(i) === r), n = {};
  for (const i of t) {
    const r = _a[i];
    if (!r) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && f.warn(`Unknown hook: ${i}`);
      continue;
    }
    for (const s of r)
      n[s] = function() {
        const o = this.$root === this;
        if (o) {
          const u = Ne();
          u && (this.$_sentryRootSpan = this.$_sentryRootSpan || u.startChild({
            description: "Application Render",
            op: `${Rn}.render`
          }));
        }
        const a = gt(this, !1), c = Array.isArray(e.trackComponents) ? e.trackComponents.indexOf(a) > -1 : e.trackComponents;
        if (!(!o && !c))
          if (this.$_sentrySpans = this.$_sentrySpans || {}, s == r[0]) {
            const u = this.$root && this.$root.$_sentryRootSpan || Ne();
            if (u) {
              const d = this.$_sentrySpans[i];
              d && !d.endTimestamp && d.finish(), this.$_sentrySpans[i] = u.startChild({
                description: `Vue <${a}>`,
                op: `${Rn}.${i}`
              });
            }
          } else {
            const u = this.$_sentrySpans[i];
            if (!u)
              return;
            u.finish(), da(this, Xt(), e.timeout);
          }
      };
  }
  return n;
}, la = I, pa = {
  Vue: la.Vue,
  attachProps: !0,
  logErrors: !0,
  hooks: di,
  timeout: 2e3,
  trackComponents: !1,
  _metadata: {
    sdk: {
      name: "sentry.javascript.vue",
      packages: [
        {
          name: "npm:@sentry/vue",
          version: $t
        }
      ],
      version: $t
    }
  }
};
function ha(e = {}) {
  const t = {
    ...pa,
    ...e
  };
  if (lo(t), !t.Vue && !t.app) {
    console.warn(
      "[@sentry/vue]: Misconfigured SDK. Vue specific errors will not be captured.\nUpdate your `Sentry.init` call with an appropriate config option:\n`app` (Application Instance - Vue 3) or `Vue` (Vue Constructor - Vue 2)."
    );
    return;
  }
  t.app ? yt(t.app).forEach((i) => bn(i, t)) : t.Vue && bn(t.Vue, t);
}
const bn = (e, t) => {
  const n = e;
  (n._instance && n._instance.isMounted) === !0 && console.warn(
    "[@sentry/vue]: Misconfigured SDK. Vue app is already mounted. Make sure to call `app.mount()` after `Sentry.init()`."
  ), ua(e, t), Jt(t) && e.mixin(
    fa({
      ...t,
      ...t.tracingOptions
    })
  );
};
function ma(e, t = {}) {
  return (n, i = !0, r = !0) => {
    const s = {
      "routing.instrumentation": "vue-router"
    };
    i && g && g.location && n({
      name: g.location.pathname,
      op: "pageload",
      tags: s,
      metadata: {
        source: "url"
      }
    }), e.onError((o) => $e(o)), e.beforeEach((o, a, c) => {
      const u = a.name == null && a.matched.length === 0, d = {
        params: o.params,
        query: o.query
      };
      let _ = o.path, p = "url";
      if (o.name && t.routeLabel !== "path" ? (_ = o.name.toString(), p = "custom") : o.matched[0] && o.matched[0].path && (_ = o.matched[0].path, p = "route"), i && u) {
        const l = Ne();
        l && (l.metadata.source !== "custom" && l.setName(_, p), l.setData("params", d.params), l.setData("query", d.query));
      }
      r && !u && n({
        name: _,
        op: "navigation",
        tags: s,
        data: d,
        metadata: {
          source: p
        }
      }), c();
    });
  };
}
let De = {
  debug: !1
};
function ga(e) {
  De = {
    ...De,
    ...e
  };
}
function ne() {
  return De.debug;
}
function Ea(e) {
  ne() && console.warn("[BugReporter] reportGlobalTags", e), zn((t) => {
    t.setTags(e);
  });
}
function ya(e) {
  ne() && console.warn("[BugReporter] reportIdentify", e), zn((t) => {
    t.setUser(e);
  });
}
(typeof __SENTRY_TRACING__ > "u" || __SENTRY_TRACING__) && ia();
function Sa(e) {
  ga({ debug: e.debug ?? !1 });
  const t = [];
  e.browserTracing && t.push(new je({
    routingInstrumentation: ma(e.browserTracing.router),
    tracingOrigins: e.browserTracing.origins
  })), ne() && console.warn("[BugReporter] init", e);
  const n = e.jsFramework === "Vue 2" ? "Vue" : "app";
  ha({
    [n]: e.app,
    dsn: e.dsn,
    enabled: e.enabled ?? !0,
    release: e.release,
    environment: e.environment,
    integrations: t
  });
}
function Ta(e, t) {
  ne() && console.warn("[BugReporter] report", e, t), $e(e, {
    tags: t == null ? void 0 : t.tags,
    contexts: {
      context: {
        ...(t == null ? void 0 : t.context) ?? {}
      }
    }
  });
}
export {
  Ta as report,
  Ea as reportGlobalTags,
  ya as reportIdentify,
  Sa as reportInit
};
